type SettingsTranslation = {
  title: string;
  description: string;
  tab_general: string;
  tab_notifications: string;
  tab_security: string;
  tab_support: string;
  regional_settings: string;
  regional_settings_description: string;
  scope_user: string;
  scope_organization: string;
  organization_settings: string;
  organization_settings_description: string;
  organization_name: string;
  organization_name_placeholder: string;
  organization_name_save: string;
  organization_name_saving: string;
  organization_name_success: string;
  organization_name_error: string;
  organization_name_required: string;
  organization_logo_success: string;
  organization_logo_removed: string;
  organization_logo_error: string;
  country: string;
  country_bank_filter_note: string;
  language: string;
  regional_formatting: string;
  timezone: string;
  default_currency: string;
  country_austria: string;
  country_belgium: string;
  country_bulgaria: string;
  country_croatia: string;
  country_cyprus: string;
  country_czechia: string;
  country_denmark: string;
  country_estonia: string;
  country_finland: string;
  country_france: string;
  country_germany: string;
  country_greece: string;
  country_hungary: string;
  country_ireland: string;
  country_italy: string;
  country_latvia: string;
  country_lithuania: string;
  country_luxembourg: string;
  country_malta: string;
  country_netherlands: string;
  country_poland: string;
  country_portugal: string;
  country_romania: string;
  country_slovakia: string;
  country_slovenia: string;
  country_spain: string;
  country_sweden: string;
  language_portuguese: string;
  language_english: string;
  language_spanish: string;
  language_estonian: string;
  format_danish: string;
  format_german: string;
  format_estonian: string;
  format_english_gb: string;
  format_english_us: string;
  format_spanish: string;
  format_french: string;
  format_italian: string;
  format_dutch: string;
  format_portuguese: string;
  format_finnish: string;
  format_swedish: string;
  openbanking_availability: string;
  openbanking_availability_description: string;
  openbanking_country_info: string;
  eu_countries_supported: string;
  compliant: string;
  powered: string;
  openbanking_available: string;
  openbanking_available_description: string;
  openbanking_limited: string;
  openbanking_limited_description: string;
  manage_bank_connections: string;
  learn_more_openbanking: string;
  notification_preferences: string;
  notification_preferences_description: string;
  document_request_uploads: string;
  document_request_uploads_description: string;
  notification_preferences_update_error: string;
  notification_preferences_update_success: string;
  budget_alerts: string;
  budget_alerts_description: string;
  transaction_updates: string;
  transaction_updates_description: string;
  weekly_summary: string;
  weekly_summary_description: string;
  ai_insights: string;
  ai_insights_description: string;
  cashflow_warnings: string;
  cashflow_warnings_description: string;
  monthly_reports: string;
  monthly_reports_description: string;
  email_change_title: string;
  email_change_description: string;
  current_email: string;
  new_email: string;
  email_change_hint: string;
  request_email_change: string;
  requesting_email_change: string;
  email_change_success: string;
  email_change_error_missing_fields: string;
  email_change_error_invalid_password: string;
  email_change_error_in_use: string;
  email_change_error_invalid_email: string;
  email_change_error_unchanged: string;
  email_change_error_generic: string;
  password: string;
  password_description: string;
  current_password: string;
  new_password: string;
  confirm_new_password: string;
  change_password: string;
  connected_accounts: string;
  connected_accounts_description: string;
  google: string;
  microsoft: string;
  apple: string;
  connected: string;
  enabled: string;
  connect: string;
  disable: string;
  cancel: string;
  copy: string;
  copied: string;
  connect_google_account: string;
  connect_microsoft_account: string;
  connect_apple_id: string;
  two_factor_authentication: string;
  two_factor_authentication_description: string;
  two_factor_auth_label: string;
  two_factor_setup_title: string;
  two_factor_setup_description: string;
  two_factor_setup_qr_label: string;
  two_factor_setup_qr_hint: string;
  two_factor_setup_qr_alt: string;
  two_factor_qr_loading: string;
  two_factor_qr_unavailable: string;
  two_factor_setup_key_label: string;
  two_factor_verification_code: string;
  two_factor_verification_code_placeholder: string;
  two_factor_enable_button: string;
  two_factor_disable_title: string;
  two_factor_disable_description: string;
  two_factor_disable_use_recovery: string;
  two_factor_disable_button: string;
  two_factor_recovery_title: string;
  two_factor_recovery_description: string;
  two_factor_recovery_copy: string;
  two_factor_recovery_done: string;
  two_factor_recovery_left: string;
  two_factor_error_invalid: string;
  two_factor_error_generic: string;
  not_enabled: string;
  enable: string;
  active_sessions: string;
  active_sessions_description: string;
  active_sessions_loading: string;
  current_session: string;
  other_session: string;
  current_session_details: string;
  active: string;
  sign_out_all_other_sessions: string;
  active_sessions_revoked: string;
  active_sessions_error: string;
  support: string;
  support_description: string;
  contact_support: string;
  contact_support_description: string;
  contact_us: string;
  feedback: string;
  feedback_description: string;
  give_feedback: string;
};

export const settingsTranslations: Record<string, SettingsTranslation> = {
  da: {
    title: "Indstillinger",
    description: "Konfigurer dine kontoindstillinger",
    tab_general: "GENERELT",
    tab_notifications: "MEDDELELSER",
    tab_security: "SIKKERHED",
    tab_support: "SUPPORT",
    regional_settings: "Regionale Indstillinger",
    regional_settings_description: "Konfigurer placering og sprog",
    scope_user: "Bruger",
    scope_organization: "Organisation",
    organization_settings: "Organisation",
    organization_settings_description: "Opdater navnet, der vises i topbjælken",
    organization_name: "Organisationsnavn",
    organization_name_placeholder: "Organisationsnavn",
    organization_name_save: "Gem navn",
    organization_name_saving: "Gemmer...",
    organization_name_success: "Organisationsnavn opdateret.",
    organization_name_error: "Kunne ikke opdatere organisationsnavn.",
    organization_name_required: "Organisationsnavn er påkrævet.",
    organization_logo_success: "Organisationslogo opdateret.",
    organization_logo_removed: "Organisationslogo fjernet.",
    organization_logo_error: "Kunne ikke opdatere organisationslogo.",
    country: "Land",
    country_bank_filter_note: "Tilgængelige bankforbindelser filtreres baseret på det valgte land",
    language: "Sprog",
    regional_formatting: "Regional Formatering",
    timezone: "Tidszone",
    default_currency: "Standardvaluta",
    country_austria: "Østrig",
    country_belgium: "Belgien",
    country_bulgaria: "Bulgarien",
    country_croatia: "Kroatien",
    country_cyprus: "Cypern",
    country_czechia: "Tjekkiet",
    country_denmark: "Danmark",
    country_estonia: "Estland",
    country_finland: "Finland",
    country_france: "Frankrig",
    country_germany: "Tyskland",
    country_greece: "Grækenland",
    country_hungary: "Ungarn",
    country_ireland: "Irland",
    country_italy: "Italien",
    country_latvia: "Letland",
    country_lithuania: "Litauen",
    country_luxembourg: "Luxembourg",
    country_malta: "Malta",
    country_netherlands: "Nederlandene",
    country_poland: "Polen",
    country_portugal: "Portugal",
    country_romania: "Rumænien",
    country_slovakia: "Slovakiet",
    country_slovenia: "Slovenien",
    country_spain: "Spanien",
    country_sweden: "Sverige",
    language_portuguese: "Portugisisk",
    language_english: "Engelsk",
    language_spanish: "Spansk",
    language_estonian: "Estisk",
    format_danish: "Dansk (Danmark)",
    format_german: "Tysk (Tyskland)",
    format_estonian: "Estisk (Estland)",
    format_english_gb: "Engelsk (Storbritannien)",
    format_english_us: "Engelsk (USA)",
    format_spanish: "Spansk (Spanien)",
    format_french: "Fransk (Frankrig)",
    format_italian: "Italiensk (Italien)",
    format_dutch: "Hollandsk (Nederlandene)",
    format_portuguese: "Portugisisk (Portugal)",
    format_finnish: "Finsk (Finland)",
    format_swedish: "Svensk (Sverige)",
    openbanking_availability: "Open Banking-tilgængelighed",
    openbanking_availability_description: "Information om tilgængelige banker efter region",
    openbanking_country_info: "Det valgte land bestemmer hvilke banker der er tilgængelige via Open Banking. MoneyLights har adgang til alle EU-banker gennem vores Yapily-integration.",
    eu_countries_supported: "27 EU-lande",
    compliant: "Overholder",
    powered: "Powered",
    openbanking_available: "Open Banking tilgængelig",
    openbanking_available_description: "Du kan forbinde alle tilgængelige banker i dette land via Open Banking.",
    openbanking_limited: "Open Banking begrænset",
    openbanking_limited_description: "Dette land har begrænset Open Banking-tilgængelighed. Kun EU-banker er tilgængelige.",
    manage_bank_connections: "Administrer bankforbindelser",
    learn_more_openbanking: "Læs mere",
    notification_preferences: "Meddelelses Præferencer",
    notification_preferences_description: "Konfigurer hvordan du modtager notifikationer",
    document_request_uploads: "Uploads af anmodede dokumenter",
    document_request_uploads_description: "Få en notifikation, når nogen uploader et anmodet dokument",
    notification_preferences_update_error: "Kunne ikke gemme notifikationspræferencer.",
    notification_preferences_update_success: "Notifikationspræferencer er gemt.",
    budget_alerts: "Budgetadvarsler",
    budget_alerts_description: "Få besked når budgetgrænser nærmer sig",
    transaction_updates: "Transaktionsopdateringer",
    transaction_updates_description: "Modtag meddelelser om nye transaktioner",
    weekly_summary: "Ugentlig Oversigt",
    weekly_summary_description: "Modtag en ugentlig finansiel oversigt via e-mail",
    ai_insights: "AI-Indsigter",
    ai_insights_description: "Modtag AI-genererede finansielle indsigter",
    cashflow_warnings: "Pengestrømsadvarsler",
    cashflow_warnings_description: "Advar mig når pengestrømmen bliver negativ",
    monthly_reports: "Månedlige Rapporter",
    monthly_reports_description: "Modtag månedlige finansielle rapporter",
    email_change_title: "E-mailadresse",
    email_change_description: "Opdater din login-e-mail",
    current_email: "Nuværende e-mail",
    new_email: "Ny e-mail",
    email_change_hint: "Vi sender et bekræftelseslink til den nye e-mailadresse.",
    request_email_change: "Anmod om ændring af e-mail",
    requesting_email_change: "Anmoder...",
    email_change_success: "Tjek din nye e-mail for at bekræfte ændringen.",
    email_change_error_missing_fields: "Indtast en ny e-mail og din nuværende adgangskode.",
    email_change_error_invalid_password: "Forkert adgangskode.",
    email_change_error_in_use: "Denne e-mail er allerede i brug.",
    email_change_error_invalid_email: "Indtast en gyldig e-mailadresse.",
    email_change_error_unchanged: "Den nye e-mail er den samme som den nuværende.",
    email_change_error_generic: "Kunne ikke anmode om ændring af e-mail.",
    password: "Adgangskode",
    password_description: "Skift din adgangskode",
    current_password: "Nuværende Adgangskode",
    new_password: "Ny Adgangskode",
    confirm_new_password: "Bekræft Ny Adgangskode",
    change_password: "Skift Adgangskode",
    connected_accounts: "Forbundne Konti",
    connected_accounts_description: "Administrer godkendelsesmetoder",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Forbundet",
    enabled: "Aktiveret",
    connect: "Forbind",
    disable: "Deaktiver",
    cancel: "Annuller",
    copy: "Kopiér",
    copied: "Kopieret",
    connect_google_account: "Forbind din Google-konto",
    connect_microsoft_account: "Forbind din Microsoft-konto",
    connect_apple_id: "Forbind dit Apple-ID",
    two_factor_authentication: "To-Faktor-Godkendelse",
    two_factor_authentication_description: "Tilføj et ekstra sikkerhedslag",
    two_factor_auth_label: "To-Faktor-Godkendelse",
    two_factor_setup_title: "Opsæt autentificeringsapp",
    two_factor_setup_description: "Indtast denne opsætningsnøgle i din autentificeringsapp, og bekræft med en 6-cifret kode.",
    two_factor_setup_qr_label: "Scan QR-kode",
    two_factor_setup_qr_hint: "Scan med din autentificeringsapp for at tilføje MoneyLights.",
    two_factor_setup_qr_alt: "QR-kode til autentificering",
    two_factor_qr_loading: "Genererer QR-kode...",
    two_factor_qr_unavailable: "QR-koden er ikke tilgængelig. Brug opsætningsnøglen i stedet.",
    two_factor_setup_key_label: "Opsætningsnøgle",
    two_factor_verification_code: "Bekræftelseskode",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Aktivér 2FA",
    two_factor_disable_title: "Deaktiver tofaktorgodkendelse",
    two_factor_disable_description: "Indtast en kode fra din autentificeringsapp eller en gendannelseskode for at deaktivere.",
    two_factor_disable_use_recovery: "Brug en gendannelseskode",
    two_factor_disable_button: "Deaktiver 2FA",
    two_factor_recovery_title: "Gendannelseskoder",
    two_factor_recovery_description: "Gem disse koder et sikkert sted. Hver kode kan kun bruges én gang.",
    two_factor_recovery_copy: "Kopiér gendannelseskoder",
    two_factor_recovery_done: "Jeg har gemt dem",
    two_factor_recovery_left: "Gendannelseskoder tilbage: {{count}}",
    two_factor_error_invalid: "Ugyldig kode. Prøv igen.",
    two_factor_error_generic: "Kunne ikke opdatere tofaktorgodkendelse.",
    not_enabled: "Ikke aktiveret",
    enable: "Aktiver",
    active_sessions: "Aktive Sessioner",
    active_sessions_description: "Administrer dine aktive login-sessioner",
    active_sessions_loading: "Indlæser sessioner...",
    current_session: "Nuværende Session",
    other_session: "Anden session",
    current_session_details: "Lissabon, Portugal • Chrome på Mac",
    active: "Aktiv",
    sign_out_all_other_sessions: "Log ud af alle andre sessioner",
    active_sessions_revoked: "Alle andre sessioner er logget ud.",
    active_sessions_error: "Kunne ikke logge ud af andre sessioner.",
    support: "Support og hjælp",
    support_description: "Få hjælp og send feedback om MoneyLights",
    contact_support: "Kontakt support",
    contact_support_description: "Tal med vores team ved spørgsmål eller problemer",
    contact_us: "Kontakt os",
    feedback: "Send feedback",
    feedback_description: "Del dine forslag eller rapporter problemer",
    give_feedback: "Giv feedback",
  },
  de: {
    title: "Einstellungen",
    description: "Konfigurieren Sie Ihre Kontoeinstellungen",
    tab_general: "ALLGEMEIN",
    tab_notifications: "BENACHRICHTIGUNGEN",
    tab_security: "SICHERHEIT",
    tab_support: "SUPPORT",
    regional_settings: "Regionale Einstellungen",
    regional_settings_description: "Standort und Sprache konfigurieren",
    scope_user: "Benutzer",
    scope_organization: "Organisation",
    organization_settings: "Organisation",
    organization_settings_description: "Aktualisieren Sie den Namen in der oberen Leiste",
    organization_name: "Organisationsname",
    organization_name_placeholder: "Organisationsname",
    organization_name_save: "Namen speichern",
    organization_name_saving: "Wird gespeichert...",
    organization_name_success: "Organisationsname aktualisiert.",
    organization_name_error: "Organisationsname konnte nicht aktualisiert werden.",
    organization_name_required: "Organisationsname ist erforderlich.",
    organization_logo_success: "Organisationslogo aktualisiert.",
    organization_logo_removed: "Organisationslogo entfernt.",
    organization_logo_error: "Organisationslogo konnte nicht aktualisiert werden.",
    country: "Land",
    country_bank_filter_note: "Verfügbare Bankverbindungen werden basierend auf dem ausgewählten Land gefiltert",
    language: "Sprache",
    regional_formatting: "Regionale Formatierung",
    timezone: "Zeitzone",
    default_currency: "Standardwährung",
    country_austria: "Österreich",
    country_belgium: "Belgien",
    country_bulgaria: "Bulgarien",
    country_croatia: "Kroatien",
    country_cyprus: "Zypern",
    country_czechia: "Tschechien",
    country_denmark: "Dänemark",
    country_estonia: "Estland",
    country_finland: "Finnland",
    country_france: "Frankreich",
    country_germany: "Deutschland",
    country_greece: "Griechenland",
    country_hungary: "Ungarn",
    country_ireland: "Irland",
    country_italy: "Italien",
    country_latvia: "Lettland",
    country_lithuania: "Litauen",
    country_luxembourg: "Luxemburg",
    country_malta: "Malta",
    country_netherlands: "Niederlande",
    country_poland: "Polen",
    country_portugal: "Portugal",
    country_romania: "Rumänien",
    country_slovakia: "Slowakei",
    country_slovenia: "Slowenien",
    country_spain: "Spanien",
    country_sweden: "Schweden",
    language_portuguese: "Portugiesisch",
    language_english: "Englisch",
    language_spanish: "Spanisch",
    language_estonian: "Estnisch",
    format_danish: "Dänisch (Dänemark)",
    format_german: "Deutsch (Deutschland)",
    format_estonian: "Estnisch (Estland)",
    format_english_gb: "Englisch (Vereinigtes Königreich)",
    format_english_us: "Englisch (Vereinigte Staaten)",
    format_spanish: "Spanisch (Spanien)",
    format_french: "Französisch (Frankreich)",
    format_italian: "Italienisch (Italien)",
    format_dutch: "Niederländisch (Niederlande)",
    format_portuguese: "Portugiesisch (Portugal)",
    format_finnish: "Finnisch (Finnland)",
    format_swedish: "Schwedisch (Schweden)",
    openbanking_availability: "Open-Banking-Verfügbarkeit",
    openbanking_availability_description: "Informationen über verfügbare Banken nach Region",
    openbanking_country_info: "Das ausgewählte Land bestimmt, welche Banken über Open Banking verfügbar sind. MoneyLights hat über unsere Yapily-Integration Zugriff auf alle Banken der Europäischen Union.",
    eu_countries_supported: "27 EU-Länder",
    compliant: "Konform",
    powered: "Powered",
    openbanking_available: "Open Banking verfügbar",
    openbanking_available_description: "Sie können alle in diesem Land verfügbaren Banken über Open Banking verbinden.",
    openbanking_limited: "Open Banking eingeschränkt",
    openbanking_limited_description: "Dieses Land hat eine eingeschränkte Open-Banking-Verfügbarkeit. Nur EU-Banken sind verfügbar.",
    manage_bank_connections: "Bankverbindungen verwalten",
    learn_more_openbanking: "Mehr erfahren",
    notification_preferences: "Benachrichtigungseinstellungen",
    notification_preferences_description: "Benachrichtigungsempfang konfigurieren",
    document_request_uploads: "Uploads angeforderter Dokumente",
    document_request_uploads_description: "Benachrichtigt werden, wenn jemand ein angefordertes Dokument hochlädt",
    notification_preferences_update_error: "Benachrichtigungseinstellungen konnten nicht gespeichert werden.",
    notification_preferences_update_success: "Benachrichtigungseinstellungen wurden gespeichert.",
    budget_alerts: "Budget-Benachrichtigungen",
    budget_alerts_description: "Bei Annäherung an Budgetgrenzen benachrichtigen",
    transaction_updates: "Transaktionsaktualisierungen",
    transaction_updates_description: "Benachrichtigungen für neue Transaktionen",
    weekly_summary: "Wöchentliche Zusammenfassung",
    weekly_summary_description: "Wöchentliche Finanzzusammenfassung per E-Mail",
    ai_insights: "KI-Einblicke",
    ai_insights_description: "KI-generierte finanzielle Einblicke erhalten",
    cashflow_warnings: "Cashflow-Warnungen",
    cashflow_warnings_description: "Bei negativem Cashflow benachrichtigen",
    monthly_reports: "Monatsberichte",
    monthly_reports_description: "Monatliche Finanzberichte erhalten",
    email_change_title: "E-Mail-Adresse",
    email_change_description: "Aktualisieren Sie Ihre Anmelde-E-Mail",
    current_email: "Aktuelle E-Mail",
    new_email: "Neue E-Mail",
    email_change_hint: "Wir senden einen Bestätigungslink an die neue E-Mail-Adresse.",
    request_email_change: "E-Mail-Änderung anfordern",
    requesting_email_change: "Wird angefordert...",
    email_change_success: "Prüfen Sie Ihre neue E-Mail, um die Änderung zu bestätigen.",
    email_change_error_missing_fields: "Geben Sie eine neue E-Mail und Ihr aktuelles Passwort ein.",
    email_change_error_invalid_password: "Falsches Passwort.",
    email_change_error_in_use: "Diese E-Mail wird bereits verwendet.",
    email_change_error_invalid_email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    email_change_error_unchanged: "Die neue E-Mail entspricht der aktuellen.",
    email_change_error_generic: "E-Mail-Änderung konnte nicht angefordert werden.",
    password: "Passwort",
    password_description: "Passwort ändern",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    confirm_new_password: "Neues Passwort bestätigen",
    change_password: "Passwort ändern",
    connected_accounts: "Verbundene Konten",
    connected_accounts_description: "Authentifizierungsmethoden verwalten",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Verbunden",
    enabled: "Aktiviert",
    connect: "Verbinden",
    disable: "Deaktivieren",
    cancel: "Abbrechen",
    copy: "Kopieren",
    copied: "Kopiert",
    connect_google_account: "Google-Konto verbinden",
    connect_microsoft_account: "Microsoft-Konto verbinden",
    connect_apple_id: "Apple-ID verbinden",
    two_factor_authentication: "Zwei-Faktor-Authentifizierung",
    two_factor_authentication_description: "Zusätzliche Sicherheitsebene hinzufügen",
    two_factor_auth_label: "Zwei-Faktor-Authentifizierung",
    two_factor_setup_title: "Authenticator-App einrichten",
    two_factor_setup_description: "Gib diesen Setup-Schlüssel in deine Authenticator-App ein und bestätige mit einem 6-stelligen Code.",
    two_factor_setup_qr_label: "QR-Code scannen",
    two_factor_setup_qr_hint: "Scanne mit deiner Authenticator-App, um MoneyLights hinzuzufügen.",
    two_factor_setup_qr_alt: "Authenticator-QR-Code",
    two_factor_qr_loading: "QR-Code wird erstellt...",
    two_factor_qr_unavailable: "QR-Code nicht verfügbar. Verwende stattdessen den Setup-Schlüssel.",
    two_factor_setup_key_label: "Setup-Schlüssel",
    two_factor_verification_code: "Bestätigungscode",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "2FA aktivieren",
    two_factor_disable_title: "Zwei-Faktor-Authentifizierung deaktivieren",
    two_factor_disable_description: "Gib einen Code aus deiner Authenticator-App oder einen Wiederherstellungscode ein, um zu deaktivieren.",
    two_factor_disable_use_recovery: "Wiederherstellungscode verwenden",
    two_factor_disable_button: "2FA deaktivieren",
    two_factor_recovery_title: "Wiederherstellungscodes",
    two_factor_recovery_description: "Bewahre diese Codes an einem sicheren Ort auf. Jeder Code kann nur einmal verwendet werden.",
    two_factor_recovery_copy: "Wiederherstellungscodes kopieren",
    two_factor_recovery_done: "Ich habe sie gespeichert",
    two_factor_recovery_left: "Verbleibende Wiederherstellungscodes: {{count}}",
    two_factor_error_invalid: "Ungültiger Code. Versuch es erneut.",
    two_factor_error_generic: "Zwei-Faktor-Authentifizierung konnte nicht aktualisiert werden.",
    not_enabled: "Nicht aktiviert",
    enable: "Aktivieren",
    active_sessions: "Aktive Sitzungen",
    active_sessions_description: "Aktive Anmeldesitzungen verwalten",
    active_sessions_loading: "Sitzungen werden geladen...",
    current_session: "Aktuelle Sitzung",
    other_session: "Andere Sitzung",
    current_session_details: "Lissabon, Portugal • Chrome auf Mac",
    active: "Aktiv",
    sign_out_all_other_sessions: "Alle anderen Sitzungen abmelden",
    active_sessions_revoked: "Alle anderen Sitzungen wurden abgemeldet.",
    active_sessions_error: "Andere Sitzungen konnten nicht abgemeldet werden.",
    support: "Support & Hilfe",
    support_description: "Hilfe erhalten und Feedback zu MoneyLights senden",
    contact_support: "Support kontaktieren",
    contact_support_description: "Sprechen Sie mit unserem Team bei Fragen oder Problemen",
    contact_us: "Kontakt",
    feedback: "Feedback senden",
    feedback_description: "Teilen Sie Ihre Vorschläge oder melden Sie Probleme",
    give_feedback: "Feedback geben",
  },
  en: {
    title: "Settings",
    description: "Configure your account preferences and application settings",
    tab_general: "GENERAL",
    tab_notifications: "NOTIFICATIONS",
    tab_security: "SECURITY",
    tab_support: "SUPPORT",
    regional_settings: "Regional Settings",
    regional_settings_description: "Configure your location and language preferences",
    scope_user: "User",
    scope_organization: "Organization",
    organization_settings: "Organization",
    organization_settings_description: "Update the name shown in the top bar",
    organization_name: "Organization name",
    organization_name_placeholder: "Organization name",
    organization_name_save: "Save name",
    organization_name_saving: "Saving...",
    organization_name_success: "Organization name updated.",
    organization_name_error: "Failed to update organization name.",
    organization_name_required: "Organization name is required.",
    organization_logo_success: "Organization logo updated.",
    organization_logo_removed: "Organization logo removed.",
    organization_logo_error: "Failed to update organization logo.",
    country: "Country",
    country_bank_filter_note: "Available bank connections will be filtered based on the selected country",
    language: "Language",
    regional_formatting: "Regional Formatting",
    timezone: "Timezone",
    default_currency: "Default Currency",
    country_austria: "Austria",
    country_belgium: "Belgium",
    country_bulgaria: "Bulgaria",
    country_croatia: "Croatia",
    country_cyprus: "Cyprus",
    country_czechia: "Czech Republic",
    country_denmark: "Denmark",
    country_estonia: "Estonia",
    country_finland: "Finland",
    country_france: "France",
    country_germany: "Germany",
    country_greece: "Greece",
    country_hungary: "Hungary",
    country_ireland: "Ireland",
    country_italy: "Italy",
    country_latvia: "Latvia",
    country_lithuania: "Lithuania",
    country_luxembourg: "Luxembourg",
    country_malta: "Malta",
    country_netherlands: "Netherlands",
    country_poland: "Poland",
    country_portugal: "Portugal",
    country_romania: "Romania",
    country_slovakia: "Slovakia",
    country_slovenia: "Slovenia",
    country_spain: "Spain",
    country_sweden: "Sweden",
    language_portuguese: "Português",
    language_english: "English",
    language_spanish: "Español",
    language_estonian: "Eesti",
    format_danish: "Danish (Denmark)",
    format_german: "German (Germany)",
    format_estonian: "Estonian (Estonia)",
    format_english_gb: "English (United Kingdom)",
    format_english_us: "English (United States)",
    format_spanish: "Spanish (Spain)",
    format_french: "French (France)",
    format_italian: "Italian (Italy)",
    format_dutch: "Dutch (Netherlands)",
    format_portuguese: "Portuguese (Portugal)",
    format_finnish: "Finnish (Finland)",
    format_swedish: "Swedish (Sweden)",
    openbanking_availability: "Open Banking Availability",
    openbanking_availability_description: "Information about available banks by region",
    openbanking_country_info: "Your selected country determines which banks will be available for connection via Open Banking. MoneyLights has access to all European Union banks through our Yapily integration.",
    eu_countries_supported: "27 EU Countries",
    compliant: "Compliant",
    powered: "Powered",
    openbanking_available: "Open Banking Available",
    openbanking_available_description: "You can connect all available banks in this country via Open Banking.",
    openbanking_limited: "Open Banking Limited",
    openbanking_limited_description: "This country has limited Open Banking availability. Only EU banks are available.",
    manage_bank_connections: "Manage Bank Connections",
    learn_more_openbanking: "Learn More",
    notification_preferences: "Notification Preferences",
    notification_preferences_description: "Configure how you receive alerts",
    document_request_uploads: "Document request uploads",
    document_request_uploads_description: "Get notified when someone uploads a requested document",
    notification_preferences_update_error: "Unable to update notification preferences.",
    notification_preferences_update_success: "Notification preferences saved.",
    budget_alerts: "Budget Alerts",
    budget_alerts_description: "Be notified when approaching budget limits",
    transaction_updates: "Transaction Updates",
    transaction_updates_description: "Receive notifications for new transactions",
    weekly_summary: "Weekly Summary",
    weekly_summary_description: "Receive a weekly financial summary via email",
    ai_insights: "AI Insights",
    ai_insights_description: "Receive financial insights generated by AI",
    cashflow_warnings: "Cash Flow Warnings",
    cashflow_warnings_description: "Alert me when cash flow goes negative",
    monthly_reports: "Monthly Reports",
    monthly_reports_description: "Receive monthly financial reports",
    email_change_title: "Email Address",
    email_change_description: "Update your sign-in email address",
    current_email: "Current email",
    new_email: "New email",
    email_change_hint: "We'll send a confirmation link to the new email address.",
    request_email_change: "Request email change",
    requesting_email_change: "Requesting...",
    email_change_success: "Check your new email to confirm the change.",
    email_change_error_missing_fields: "Enter a new email and your current password.",
    email_change_error_invalid_password: "Incorrect password.",
    email_change_error_in_use: "That email is already in use.",
    email_change_error_invalid_email: "Please enter a valid email address.",
    email_change_error_unchanged: "New email matches the current one.",
    email_change_error_generic: "Unable to request email change.",
    password: "Password",
    password_description: "Change your password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_new_password: "Confirm New Password",
    change_password: "Change Password",
    connected_accounts: "Connected Accounts",
    connected_accounts_description: "Manage authentication methods for your account",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Connected",
    enabled: "Enabled",
    connect: "Connect",
    disable: "Disable",
    cancel: "Cancel",
    copy: "Copy",
    copied: "Copied",
    connect_google_account: "Connect your Google account",
    connect_microsoft_account: "Connect your Microsoft account",
    connect_apple_id: "Connect your Apple ID",
    two_factor_authentication: "Two-Factor Authentication",
    two_factor_authentication_description: "Add an extra layer of security to your account",
    two_factor_auth_label: "Two-Factor Authentication",
    two_factor_setup_title: "Set up your authenticator app",
    two_factor_setup_description: "Enter this setup key in your authenticator app, then verify with a 6-digit code.",
    two_factor_setup_qr_label: "Scan QR code",
    two_factor_setup_qr_hint: "Scan with your authenticator app to add MoneyLights.",
    two_factor_setup_qr_alt: "Authenticator QR code",
    two_factor_qr_loading: "Generating QR code...",
    two_factor_qr_unavailable: "QR code unavailable. Use the setup key instead.",
    two_factor_setup_key_label: "Setup key",
    two_factor_verification_code: "Verification code",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Enable 2FA",
    two_factor_disable_title: "Disable two-factor authentication",
    two_factor_disable_description: "Enter a code from your authenticator app or a recovery code to disable.",
    two_factor_disable_use_recovery: "Use a recovery code",
    two_factor_disable_button: "Disable 2FA",
    two_factor_recovery_title: "Recovery codes",
    two_factor_recovery_description: "Save these codes in a safe place. Each code can be used once.",
    two_factor_recovery_copy: "Copy recovery codes",
    two_factor_recovery_done: "I've saved them",
    two_factor_recovery_left: "Recovery codes left: {{count}}",
    two_factor_error_invalid: "Invalid code. Try again.",
    two_factor_error_generic: "Unable to update two-factor authentication.",
    not_enabled: "Not enabled",
    enable: "Enable",
    active_sessions: "Active Sessions",
    active_sessions_description: "Manage your active login sessions",
    active_sessions_loading: "Loading sessions...",
    current_session: "Current Session",
    other_session: "Other Session",
    current_session_details: "Lisbon, Portugal • Chrome on Mac",
    active: "Active",
    sign_out_all_other_sessions: "Sign Out All Other Sessions",
    active_sessions_revoked: "All other sessions have been signed out.",
    active_sessions_error: "Couldn't sign out other sessions.",
    support: "Support & Help",
    support_description: "Get help and send feedback about MoneyLights",
    contact_support: "Contact Support",
    contact_support_description: "Speak with our team for questions or issues",
    contact_us: "Contact Us",
    feedback: "Send Feedback",
    feedback_description: "Share your suggestions or report issues",
    give_feedback: "Give Feedback",
  },
  es: {
    title: "Configuración",
    description: "Configurar las preferencias de tu cuenta y la configuración de la aplicación",
    tab_general: "GENERAL",
    tab_notifications: "NOTIFICACIONES",
    tab_security: "SEGURIDAD",
    tab_support: "SOPORTE",
    regional_settings: "Configuración Regional",
    regional_settings_description: "Configurar tus preferencias de ubicación e idioma",
    scope_user: "Usuario",
    scope_organization: "Organización",
    organization_settings: "Organización",
    organization_settings_description: "Actualiza el nombre que aparece en la barra superior",
    organization_name: "Nombre de la organización",
    organization_name_placeholder: "Nombre de la organización",
    organization_name_save: "Guardar nombre",
    organization_name_saving: "Guardando...",
    organization_name_success: "Nombre de la organización actualizado.",
    organization_name_error: "No se pudo actualizar el nombre de la organización.",
    organization_name_required: "El nombre de la organización es obligatorio.",
    organization_logo_success: "Logotipo de la organización actualizado.",
    organization_logo_removed: "Logotipo de la organización eliminado.",
    organization_logo_error: "No se pudo actualizar el logotipo de la organización.",
    country: "País",
    country_bank_filter_note: "Las conexiones bancarias disponibles se filtrarán según el país seleccionado",
    language: "Idioma",
    regional_formatting: "Formato Regional",
    timezone: "Zona Horaria",
    default_currency: "Moneda Predeterminada",
    country_austria: "Austria",
    country_belgium: "Bélgica",
    country_bulgaria: "Bulgaria",
    country_croatia: "Croacia",
    country_cyprus: "Chipre",
    country_czechia: "República Checa",
    country_denmark: "Dinamarca",
    country_estonia: "Estonia",
    country_finland: "Finlandia",
    country_france: "Francia",
    country_germany: "Alemania",
    country_greece: "Grecia",
    country_hungary: "Hungría",
    country_ireland: "Irlanda",
    country_italy: "Italia",
    country_latvia: "Letonia",
    country_lithuania: "Lituania",
    country_luxembourg: "Luxemburgo",
    country_malta: "Malta",
    country_netherlands: "Países Bajos",
    country_poland: "Polonia",
    country_portugal: "Portugal",
    country_romania: "Rumanía",
    country_slovakia: "Eslovaquia",
    country_slovenia: "Eslovenia",
    country_spain: "España",
    country_sweden: "Suecia",
    language_portuguese: "Portugués",
    language_english: "Inglés",
    language_spanish: "Español",
    language_estonian: "Estonio",
    format_danish: "Danés (Dinamarca)",
    format_german: "Alemán (Alemania)",
    format_estonian: "Estonio (Estonia)",
    format_english_gb: "Inglés (Reino Unido)",
    format_english_us: "Inglés (Estados Unidos)",
    format_spanish: "Español (España)",
    format_french: "Francés (Francia)",
    format_italian: "Italiano (Italia)",
    format_dutch: "Neerlandés (Países Bajos)",
    format_portuguese: "Portugués (Portugal)",
    format_finnish: "Finés (Finlandia)",
    format_swedish: "Sueco (Suecia)",
    openbanking_availability: "Disponibilidad Open Banking",
    openbanking_availability_description: "Información sobre bancos disponibles por región",
    openbanking_country_info: "El país seleccionado determina qué bancos estarán disponibles para conectar vía Open Banking. MoneyLights tiene acceso a todos los bancos de la Unión Europea a través de nuestra integración Yapily.",
    eu_countries_supported: "27 Países UE",
    compliant: "Conforme",
    powered: "Powered",
    openbanking_available: "Open Banking Disponible",
    openbanking_available_description: "Puede conectar todos los bancos disponibles en este país vía Open Banking.",
    openbanking_limited: "Open Banking Limitado",
    openbanking_limited_description: "Este país tiene disponibilidad limitada de Open Banking. Solo bancos de la UE están disponibles.",
    manage_bank_connections: "Gestionar Conexiones Bancarias",
    learn_more_openbanking: "Saber Más",
    notification_preferences: "Preferencias de Notificación",
    notification_preferences_description: "Configurar cómo recibes alertas",
    document_request_uploads: "Cargas de documentos solicitados",
    document_request_uploads_description: "Recibe notificaciones cuando alguien sube un documento solicitado",
    notification_preferences_update_error: "No se pudieron guardar las preferencias de notificación.",
    notification_preferences_update_success: "Preferencias de notificación guardadas.",
    budget_alerts: "Alertas de Presupuesto",
    budget_alerts_description: "Ser notificado cuando te acerques a los límites de presupuesto",
    transaction_updates: "Actualizaciones de Transacciones",
    transaction_updates_description: "Recibir notificaciones para nuevas transacciones",
    weekly_summary: "Resumen Semanal",
    weekly_summary_description: "Recibir un resumen financiero semanal por correo electrónico",
    ai_insights: "Insights de IA",
    ai_insights_description: "Recibir insights financieros generados por IA",
    cashflow_warnings: "Advertencias de Flujo de Caja",
    cashflow_warnings_description: "Alertarme cuando el flujo de caja sea negativo",
    monthly_reports: "Informes Mensuales",
    monthly_reports_description: "Recibir informes financieros mensuales",
    email_change_title: "Correo electrónico",
    email_change_description: "Actualiza tu correo de acceso",
    current_email: "Correo actual",
    new_email: "Nuevo correo",
    email_change_hint: "Enviaremos un enlace de confirmación al nuevo correo.",
    request_email_change: "Solicitar cambio de correo",
    requesting_email_change: "Solicitando...",
    email_change_success: "Revisa tu nuevo correo para confirmar el cambio.",
    email_change_error_missing_fields: "Introduce un nuevo correo y tu contraseña actual.",
    email_change_error_invalid_password: "Contraseña incorrecta.",
    email_change_error_in_use: "Ese correo ya está en uso.",
    email_change_error_invalid_email: "Introduce un correo válido.",
    email_change_error_unchanged: "El nuevo correo coincide con el actual.",
    email_change_error_generic: "No se pudo solicitar el cambio de correo.",
    password: "Contraseña",
    password_description: "Cambiar tu contraseña",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_new_password: "Confirmar Nueva Contraseña",
    change_password: "Cambiar Contraseña",
    connected_accounts: "Cuentas Conectadas",
    connected_accounts_description: "Gestionar métodos de autenticación para tu cuenta",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Conectado",
    enabled: "Activado",
    connect: "Conectar",
    disable: "Desactivar",
    cancel: "Cancelar",
    copy: "Copiar",
    copied: "Copiado",
    connect_google_account: "Conectar tu cuenta de Google",
    connect_microsoft_account: "Conectar tu cuenta de Microsoft",
    connect_apple_id: "Conectar tu Apple ID",
    two_factor_authentication: "Autenticación de Dos Factores",
    two_factor_authentication_description: "Agregar una capa extra de seguridad a tu cuenta",
    two_factor_auth_label: "Autenticación de Dos Factores",
    two_factor_setup_title: "Configura tu app de autenticación",
    two_factor_setup_description: "Introduce esta clave en tu app de autenticación y confirma con un código de 6 dígitos.",
    two_factor_setup_qr_label: "Escanear código QR",
    two_factor_setup_qr_hint: "Escanéalo con tu app de autenticación para añadir MoneyLights.",
    two_factor_setup_qr_alt: "Código QR del autenticador",
    two_factor_qr_loading: "Generando código QR...",
    two_factor_qr_unavailable: "Código QR no disponible. Usa la clave de configuración.",
    two_factor_setup_key_label: "Clave de configuración",
    two_factor_verification_code: "Código de verificación",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Activar 2FA",
    two_factor_disable_title: "Desactivar autenticación de dos factores",
    two_factor_disable_description: "Introduce un código de tu app de autenticación o un código de recuperación para desactivar.",
    two_factor_disable_use_recovery: "Usar un código de recuperación",
    two_factor_disable_button: "Desactivar 2FA",
    two_factor_recovery_title: "Códigos de recuperación",
    two_factor_recovery_description: "Guarda estos códigos en un lugar seguro. Cada código se puede usar una sola vez.",
    two_factor_recovery_copy: "Copiar códigos de recuperación",
    two_factor_recovery_done: "Ya los guardé",
    two_factor_recovery_left: "Códigos de recuperación restantes: {{count}}",
    two_factor_error_invalid: "Código no válido. Inténtalo de nuevo.",
    two_factor_error_generic: "No se pudo actualizar la autenticación de dos factores.",
    not_enabled: "No habilitada",
    enable: "Habilitar",
    active_sessions: "Sesiones Activas",
    active_sessions_description: "Gestionar tus sesiones de inicio de sesión activas",
    active_sessions_loading: "Cargando sesiones...",
    current_session: "Sesión Actual",
    other_session: "Otra sesión",
    current_session_details: "Lisboa, Portugal • Chrome en Mac",
    active: "Activa",
    sign_out_all_other_sessions: "Cerrar Todas las Otras Sesiones",
    active_sessions_revoked: "Se cerraron todas las demás sesiones.",
    active_sessions_error: "No se pudieron cerrar las demás sesiones.",
    support: "Soporte y Ayuda",
    support_description: "Obtén ayuda y envía comentarios sobre MoneyLights",
    contact_support: "Contactar Soporte",
    contact_support_description: "Habla con nuestro equipo para dudas o problemas",
    contact_us: "Contáctanos",
    feedback: "Enviar Comentarios",
    feedback_description: "Comparte tus sugerencias o reporta problemas",
    give_feedback: "Dar Comentarios",
  },
  et: {
    title: "Seaded",
    description: "Seadistage oma kontote eelistusi ja rakenduse seadeid",
    tab_general: "ÜLDINE",
    tab_notifications: "TEAVITUSED",
    tab_security: "TURVALISUS",
    tab_support: "TUGI",
    regional_settings: "Regionaalsete seadete haldamine",
    regional_settings_description: "Seadistage oma asukoha ja keele eelistusi",
    scope_user: "Kasutaja",
    scope_organization: "Organisatsioon",
    organization_settings: "Organisatsioon",
    organization_settings_description: "Uuenda ülaribal kuvatavat nime",
    organization_name: "Organisatsiooni nimi",
    organization_name_placeholder: "Organisatsiooni nimi",
    organization_name_save: "Salvesta nimi",
    organization_name_saving: "Salvestamine...",
    organization_name_success: "Organisatsiooni nimi uuendatud.",
    organization_name_error: "Organisatsiooni nime uuendamine ebaõnnestus.",
    organization_name_required: "Organisatsiooni nimi on kohustuslik.",
    organization_logo_success: "Organisatsiooni logo uuendatud.",
    organization_logo_removed: "Organisatsiooni logo eemaldatud.",
    organization_logo_error: "Organisatsiooni logo uuendamine ebaõnnestus.",
    country: "Riik",
    country_bank_filter_note: "Saadaolevad pangaühendused filtreeritakse valitud riigi alusel",
    language: "Keel",
    regional_formatting: "Regionaalne vormindus",
    timezone: "Ajavöönd",
    default_currency: "Vaikimisi valuuta",
    country_austria: "Austria",
    country_belgium: "Belgia",
    country_bulgaria: "Bulgaaria",
    country_croatia: "Horvaatia",
    country_cyprus: "Küpros",
    country_czechia: "Tšehhi",
    country_denmark: "Taani",
    country_estonia: "Eesti",
    country_finland: "Soome",
    country_france: "Prantsusmaa",
    country_germany: "Saksamaa",
    country_greece: "Kreeka",
    country_hungary: "Ungari",
    country_ireland: "Iirimaa",
    country_italy: "Itaalia",
    country_latvia: "Läti",
    country_lithuania: "Leedu",
    country_luxembourg: "Luksemburg",
    country_malta: "Malta",
    country_netherlands: "Madalmaad",
    country_poland: "Poola",
    country_portugal: "Portugal",
    country_romania: "Rumeenia",
    country_slovakia: "Slovakkia",
    country_slovenia: "Sloveenia",
    country_spain: "Hispaania",
    country_sweden: "Rootsi",
    language_portuguese: "Portugali",
    language_english: "Inglise",
    language_spanish: "Hispaania",
    language_estonian: "Eesti",
    format_danish: "Taani (Taani)",
    format_german: "Saksa (Saksamaa)",
    format_estonian: "Eesti (Eesti)",
    format_english_gb: "Inglise (Ühendkuningriik)",
    format_english_us: "Inglise (USA)",
    format_spanish: "Hispaania (Hispaania)",
    format_french: "Prantsuse (Prantsusmaa)",
    format_italian: "Itaalia (Itaalia)",
    format_dutch: "Hollandi (Madalmaad)",
    format_portuguese: "Portugali (Portugal)",
    format_finnish: "Soome (Soome)",
    format_swedish: "Rootsi (Rootsi)",
    openbanking_availability: "Open Banking saadavus",
    openbanking_availability_description: "Teave piirkonniti saadaval olevate pankade kohta",
    openbanking_country_info: "Valitud riik määrab, millised pangad on Open Banking ühenduse kaudu saadaval. MoneyLightsil on Yapily integratsiooni kaudu ligipääs kõigile Euroopa Liidu pankadele.",
    eu_countries_supported: "27 EL-i riiki",
    compliant: "Nõuetele vastav",
    powered: "Powered",
    openbanking_available: "Open Banking saadaval",
    openbanking_available_description: "Saate ühendada kõik selles riigis saadaval olevad pangad Open Bankinguga.",
    openbanking_limited: "Open Banking piiratud",
    openbanking_limited_description: "Selles riigis on Open Banking piiratud. Saadaval on ainult EL-i pangad.",
    manage_bank_connections: "Halda pangaühendusi",
    learn_more_openbanking: "Loe lisaks",
    notification_preferences: "Teavituste eelistused",
    notification_preferences_description: "Seadistage, kuidas saate teavitusi",
    document_request_uploads: "Taotletud dokumentide üleslaadimised",
    document_request_uploads_description: "Teavitus, kui keegi laadib üles taotletud dokumendi",
    notification_preferences_update_error: "Teavituseelistuste salvestamine ebaõnnestus.",
    notification_preferences_update_success: "Teavituseelistused on salvestatud.",
    budget_alerts: "Eelarve teavitused",
    budget_alerts_description: "Saada teavitus, kui lähitate eelarve piiridest",
    transaction_updates: "Tehingu uuendused",
    transaction_updates_description: "Saada teavitus uute tehingute kohta",
    weekly_summary: "Nädalane kokkuvõte",
    weekly_summary_description: "Saada nädalane finantslik kokkuvõte e-postiga",
    ai_insights: "AI-ülevaated",
    ai_insights_description: "Saada finantslikud ülevaated, mis on genereeritud AI-ga",
    cashflow_warnings: "Rahavoogite hoiatused",
    cashflow_warnings_description: "Hoiata, kui rahavoog muutub negatiivseks",
    monthly_reports: "Kuudeline aruanne",
    monthly_reports_description: "Saada kuudeline finantslik aruanne",
    email_change_title: "E-posti aadress",
    email_change_description: "Uuenda oma sisselogimise e-posti aadressi",
    current_email: "Praegune e-post",
    new_email: "Uus e-post",
    email_change_hint: "Saadame kinnituslingi uuele e-postile.",
    request_email_change: "Taotle e-posti muutmist",
    requesting_email_change: "Taotlemine...",
    email_change_success: "Kontrolli uut e-posti, et muudatus kinnitada.",
    email_change_error_missing_fields: "Sisesta uus e-post ja praegune parool.",
    email_change_error_invalid_password: "Vale parool.",
    email_change_error_in_use: "See e-post on juba kasutusel.",
    email_change_error_invalid_email: "Sisesta kehtiv e-posti aadress.",
    email_change_error_unchanged: "Uus e-post on sama mis praegune.",
    email_change_error_generic: "E-posti muutmise taotlemine ebaõnnestus.",
    password: "Parool",
    password_description: "Muuda oma parooli",
    current_password: "Praegune parool",
    new_password: "Uus parool",
    confirm_new_password: "Kinnita uus parool",
    change_password: "Muuda parooli",
    connected_accounts: "Ühendatud kontod",
    connected_accounts_description: "Haldage oma kontoga seotud autentimismeetodeid",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Ühendatud",
    enabled: "Lubatud",
    connect: "Ühenda",
    disable: "Lülita välja",
    cancel: "Tühista",
    copy: "Kopeeri",
    copied: "Kopeeritud",
    connect_google_account: "Ühenda oma Google konto",
    connect_microsoft_account: "Ühenda oma Microsoft konto",
    connect_apple_id: "Ühenda oma Apple ID",
    two_factor_authentication: "Kaheastmeline autentimine",
    two_factor_authentication_description: "Lisa oma kontole täiendav turvalisuse tase",
    two_factor_auth_label: "Kaheastmeline autentimine",
    two_factor_setup_title: "Seadista autentimisrakendus",
    two_factor_setup_description: "Sisesta see seadistusvõti autentimisrakendusse ja kinnita 6-kohalise koodiga.",
    two_factor_setup_qr_label: "Skanni QR-kood",
    two_factor_setup_qr_hint: "Skanni autentimisrakendusega, et lisada MoneyLights.",
    two_factor_setup_qr_alt: "Autentimisrakenduse QR-kood",
    two_factor_qr_loading: "QR-koodi loomine...",
    two_factor_qr_unavailable: "QR-kood pole saadaval. Kasuta seadistusvõtit.",
    two_factor_setup_key_label: "Seadistusvõti",
    two_factor_verification_code: "Kinnituskood",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Luba 2FA",
    two_factor_disable_title: "Kaheastmelise autentimise väljalülitamine",
    two_factor_disable_description: "Sisesta autentimisrakenduse kood või taastamiskood, et välja lülitada.",
    two_factor_disable_use_recovery: "Kasuta taastamiskoodi",
    two_factor_disable_button: "Lülita 2FA välja",
    two_factor_recovery_title: "Taastamiskoodid",
    two_factor_recovery_description: "Hoia need koodid turvalises kohas. Iga koodi saab kasutada ainult üks kord.",
    two_factor_recovery_copy: "Kopeeri taastamiskoodid",
    two_factor_recovery_done: "Olen salvestanud",
    two_factor_recovery_left: "Taastamiskoode järel: {{count}}",
    two_factor_error_invalid: "Vigane kood. Proovi uuesti.",
    two_factor_error_generic: "Kaheastmelist autentimist ei õnnestunud uuendada.",
    not_enabled: "Ei ole lubatud",
    enable: "Luba",
    active_sessions: "Aktiivsed seansid",
    active_sessions_description: "Haldage oma aktiivseid sisselogimise seansse",
    active_sessions_loading: "Seansside laadimine...",
    current_session: "Praegune sessioon",
    other_session: "Muu seanss",
    current_session_details: "Lisbona, Portugal • Chrome Macil",
    active: "Aktiivne",
    sign_out_all_other_sessions: "Logi välja kõik muud seansid",
    active_sessions_revoked: "Kõik muud seansid on lõpetatud.",
    active_sessions_error: "Muude seansside väljalogimine ebaõnnestus.",
    support: "Tugi ja abi",
    support_description: "Hangi abi ja saada tagasisidet MoneyLightsi kohta",
    contact_support: "Võta ühendust toega",
    contact_support_description: "Räägi meie tiimiga küsimuste või probleemide korral",
    contact_us: "Võta meiega ühendust",
    feedback: "Saada tagasisidet",
    feedback_description: "Jaga oma ettepanekuid või teata probleemidest",
    give_feedback: "Anna tagasisidet",
  },
  fi: {
    title: "Asetukset",
    description: "Määritä tilisi asetukset",
    tab_general: "YLEINEN",
    tab_notifications: "ILMOITUKSET",
    tab_security: "TURVALLISUUS",
    tab_support: "TUKI",
    regional_settings: "Alueelliset Asetukset",
    regional_settings_description: "Määritä sijainti ja kieli",
    scope_user: "Käyttäjä",
    scope_organization: "Organisaatio",
    organization_settings: "Organisaatio",
    organization_settings_description: "Päivitä yläpalkissa näkyvä nimi",
    organization_name: "Organisaation nimi",
    organization_name_placeholder: "Organisaation nimi",
    organization_name_save: "Tallenna nimi",
    organization_name_saving: "Tallennetaan...",
    organization_name_success: "Organisaation nimi päivitetty.",
    organization_name_error: "Organisaation nimen päivitys epäonnistui.",
    organization_name_required: "Organisaation nimi on pakollinen.",
    organization_logo_success: "Organisaation logo päivitetty.",
    organization_logo_removed: "Organisaation logo poistettu.",
    organization_logo_error: "Organisaation logon päivitys epäonnistui.",
    country: "Maa",
    country_bank_filter_note: "Saatavilla olevat pankkiyhteydet suodatetaan valitun maan perusteella",
    language: "Kieli",
    regional_formatting: "Alueellinen Muotoilu",
    timezone: "Aikavyöhyke",
    default_currency: "Oletusvaluutta",
    country_austria: "Itävalta",
    country_belgium: "Belgia",
    country_bulgaria: "Bulgaria",
    country_croatia: "Kroatia",
    country_cyprus: "Kypros",
    country_czechia: "Tšekki",
    country_denmark: "Tanska",
    country_estonia: "Viro",
    country_finland: "Suomi",
    country_france: "Ranska",
    country_germany: "Saksa",
    country_greece: "Kreikka",
    country_hungary: "Unkari",
    country_ireland: "Irlanti",
    country_italy: "Italia",
    country_latvia: "Latvia",
    country_lithuania: "Liettua",
    country_luxembourg: "Luxemburg",
    country_malta: "Malta",
    country_netherlands: "Alankomaat",
    country_poland: "Puola",
    country_portugal: "Portugali",
    country_romania: "Romania",
    country_slovakia: "Slovakia",
    country_slovenia: "Slovenia",
    country_spain: "Espanja",
    country_sweden: "Ruotsi",
    language_portuguese: "Portugali",
    language_english: "Englanti",
    language_spanish: "Espanja",
    language_estonian: "Viro",
    format_danish: "Tanska (Tanska)",
    format_german: "Saksa (Saksa)",
    format_estonian: "Viro (Viro)",
    format_english_gb: "Englanti (Iso-Britannia)",
    format_english_us: "Englanti (USA)",
    format_spanish: "Espanja (Espanja)",
    format_french: "Ranska (Ranska)",
    format_italian: "Italia (Italia)",
    format_dutch: "Hollanti (Alankomaat)",
    format_portuguese: "Portugali (Portugali)",
    format_finnish: "Suomi (Suomi)",
    format_swedish: "Ruotsi (Ruotsi)",
    openbanking_availability: "Open Banking -saatavuus",
    openbanking_availability_description: "Tietoa saatavilla olevista pankeista alueittain",
    openbanking_country_info: "Valittu maa määrittää, mitkä pankit ovat saatavilla Open Banking -yhteyden kautta. MoneyLightsilla on Yapily-integraation kautta pääsy kaikkiin Euroopan unionin pankkeihin.",
    eu_countries_supported: "27 EU-maata",
    compliant: "Yhteensopiva",
    powered: "Powered",
    openbanking_available: "Open Banking saatavilla",
    openbanking_available_description: "Voit yhdistää kaikki tässä maassa saatavilla olevat pankit Open Bankingin kautta.",
    openbanking_limited: "Open Banking rajoitettu",
    openbanking_limited_description: "Tässä maassa Open Banking -saatavuus on rajoitettu. Vain EU-pankit ovat saatavilla.",
    manage_bank_connections: "Hallitse pankkiyhteyksiä",
    learn_more_openbanking: "Lue lisää",
    notification_preferences: "Ilmoitusasetukset",
    notification_preferences_description: "Määritä miten vastaanotat ilmoituksia",
    document_request_uploads: "Pyydettyjen asiakirjojen lataukset",
    document_request_uploads_description: "Saat ilmoituksen, kun joku lataa pyydetyn asiakirjan",
    notification_preferences_update_error: "Ilmoitusasetusten tallentaminen epäonnistui.",
    notification_preferences_update_success: "Ilmoitusasetukset tallennettu.",
    budget_alerts: "Budjettihälytykset",
    budget_alerts_description: "Saa ilmoitus lähestyessäsi budjettirajoja",
    transaction_updates: "Tapahtumapäivitykset",
    transaction_updates_description: "Vastaanota ilmoituksia uusista tapahtumista",
    weekly_summary: "Viikkoyhteenveto",
    weekly_summary_description: "Vastaanota viikottainen talousyhteenveto sähköpostilla",
    ai_insights: "AI-Oivallukset",
    ai_insights_description: "Vastaanota AI:n luomia taloudellisia oivalluksia",
    cashflow_warnings: "Kassavirtavaroitukset",
    cashflow_warnings_description: "Varoita minua kun kassavirta kääntyy negatiiviseksi",
    monthly_reports: "Kuukausiraportit",
    monthly_reports_description: "Vastaanota kuukausittaisia talousraportteja",
    email_change_title: "Sähköpostiosoite",
    email_change_description: "Päivitä kirjautumissähköpostisi",
    current_email: "Nykyinen sähköposti",
    new_email: "Uusi sähköposti",
    email_change_hint: "Lähetämme vahvistuslinkin uuteen sähköpostiin.",
    request_email_change: "Pyydä sähköpostin vaihto",
    requesting_email_change: "Pyydetään...",
    email_change_success: "Tarkista uusi sähköpostisi vahvistusta varten.",
    email_change_error_missing_fields: "Syötä uusi sähköposti ja nykyinen salasana.",
    email_change_error_invalid_password: "Väärä salasana.",
    email_change_error_in_use: "Tämä sähköposti on jo käytössä.",
    email_change_error_invalid_email: "Syötä kelvollinen sähköpostiosoite.",
    email_change_error_unchanged: "Uusi sähköposti on sama kuin nykyinen.",
    email_change_error_generic: "Sähköpostin vaihdon pyytäminen epäonnistui.",
    password: "Salasana",
    password_description: "Vaihda salasanasi",
    current_password: "Nykyinen Salasana",
    new_password: "Uusi Salasana",
    confirm_new_password: "Vahvista Uusi Salasana",
    change_password: "Vaihda Salasana",
    connected_accounts: "Yhdistetyt Tilit",
    connected_accounts_description: "Hallitse todennusmenetelmiä",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Yhdistetty",
    enabled: "Käytössä",
    connect: "Yhdistä",
    disable: "Poista käytöstä",
    cancel: "Peruuta",
    copy: "Kopioi",
    copied: "Kopioitu",
    connect_google_account: "Yhdistä Google-tilisi",
    connect_microsoft_account: "Yhdistä Microsoft-tilisi",
    connect_apple_id: "Yhdistä Apple-tunnuksesi",
    two_factor_authentication: "Kaksivaiheinen Todennus",
    two_factor_authentication_description: "Lisää ylimääräinen turvakerros",
    two_factor_auth_label: "Kaksivaiheinen Todennus",
    two_factor_setup_title: "Ota todennussovellus käyttöön",
    two_factor_setup_description: "Syötä tämä avain todennussovellukseen ja vahvista 6-numeroisella koodilla.",
    two_factor_setup_qr_label: "Skannaa QR-koodi",
    two_factor_setup_qr_hint: "Skannaa todennussovelluksella lisätäksesi MoneyLightsin.",
    two_factor_setup_qr_alt: "Todennussovelluksen QR-koodi",
    two_factor_qr_loading: "Luodaan QR-koodia...",
    two_factor_qr_unavailable: "QR-koodi ei ole saatavilla. Käytä asetustunnusta.",
    two_factor_setup_key_label: "Asetusavain",
    two_factor_verification_code: "Vahvistuskoodi",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Ota 2FA käyttöön",
    two_factor_disable_title: "Poista kaksivaiheinen tunnistautuminen",
    two_factor_disable_description: "Syötä todennussovelluksen koodi tai palautuskoodi poistaaksesi käytöstä.",
    two_factor_disable_use_recovery: "Käytä palautuskoodia",
    two_factor_disable_button: "Poista 2FA",
    two_factor_recovery_title: "Palautuskoodit",
    two_factor_recovery_description: "Tallenna nämä koodit turvalliseen paikkaan. Jokainen koodi toimii vain kerran.",
    two_factor_recovery_copy: "Kopioi palautuskoodit",
    two_factor_recovery_done: "Olen tallentanut ne",
    two_factor_recovery_left: "Palautuskoodeja jäljellä: {{count}}",
    two_factor_error_invalid: "Virheellinen koodi. Yritä uudelleen.",
    two_factor_error_generic: "Kaksivaiheista tunnistautumista ei voitu päivittää.",
    not_enabled: "Ei käytössä",
    enable: "Ota Käyttöön",
    active_sessions: "Aktiiviset Istunnot",
    active_sessions_description: "Hallitse aktiivisia kirjautumisistuntojasi",
    active_sessions_loading: "Ladataan istuntoja...",
    current_session: "Nykyinen Istunto",
    other_session: "Muu istunto",
    current_session_details: "Lissabon, Portugali • Chrome Macissa",
    active: "Aktiivinen",
    sign_out_all_other_sessions: "Kirjaudu ulos kaikista muista istunnoista",
    active_sessions_revoked: "Kaikki muut istunnot on kirjattu ulos.",
    active_sessions_error: "Muiden istuntojen uloskirjaus epäonnistui.",
    support: "Tuki ja apu",
    support_description: "Saat apua ja lähetä palautetta MoneyLightsista",
    contact_support: "Ota yhteyttä tukeen",
    contact_support_description: "Keskustele tiimimme kanssa kysymyksistä tai ongelmista",
    contact_us: "Ota yhteyttä",
    feedback: "Lähetä palaute",
    feedback_description: "Jaa ehdotuksesi tai ilmoita ongelmista",
    give_feedback: "Anna palautetta",
  },
  fr: {
    title: "Paramètres",
    description: "Configurer les préférences de votre compte",
    tab_general: "GÉNÉRAL",
    tab_notifications: "NOTIFICATIONS",
    tab_security: "SÉCURITÉ",
    tab_support: "SUPPORT",
    regional_settings: "Paramètres Régionaux",
    regional_settings_description: "Configurer la localisation et la langue",
    scope_user: "Utilisateur",
    scope_organization: "Organisation",
    organization_settings: "Organisation",
    organization_settings_description: "Mettre à jour le nom affiché dans la barre supérieure",
    organization_name: "Nom de l'organisation",
    organization_name_placeholder: "Nom de l'organisation",
    organization_name_save: "Enregistrer le nom",
    organization_name_saving: "Enregistrement...",
    organization_name_success: "Nom de l'organisation mis à jour.",
    organization_name_error: "Impossible de mettre à jour le nom de l'organisation.",
    organization_name_required: "Le nom de l'organisation est obligatoire.",
    organization_logo_success: "Logo de l'organisation mis à jour.",
    organization_logo_removed: "Logo de l'organisation supprimé.",
    organization_logo_error: "Impossible de mettre à jour le logo de l'organisation.",
    country: "Pays",
    country_bank_filter_note: "Les connexions bancaires disponibles seront filtrées en fonction du pays sélectionné",
    language: "Langue",
    regional_formatting: "Formatage Régional",
    timezone: "Fuseau Horaire",
    default_currency: "Devise par Défaut",
    country_austria: "Autriche",
    country_belgium: "Belgique",
    country_bulgaria: "Bulgarie",
    country_croatia: "Croatie",
    country_cyprus: "Chypre",
    country_czechia: "République Tchèque",
    country_denmark: "Danemark",
    country_estonia: "Estonie",
    country_finland: "Finlande",
    country_france: "France",
    country_germany: "Allemagne",
    country_greece: "Grèce",
    country_hungary: "Hongrie",
    country_ireland: "Irlande",
    country_italy: "Italie",
    country_latvia: "Lettonie",
    country_lithuania: "Lituanie",
    country_luxembourg: "Luxembourg",
    country_malta: "Malte",
    country_netherlands: "Pays-Bas",
    country_poland: "Pologne",
    country_portugal: "Portugal",
    country_romania: "Roumanie",
    country_slovakia: "Slovaquie",
    country_slovenia: "Slovénie",
    country_spain: "Espagne",
    country_sweden: "Suède",
    language_portuguese: "Portugais",
    language_english: "Anglais",
    language_spanish: "Espagnol",
    language_estonian: "Estonien",
    format_danish: "Danois (Danemark)",
    format_german: "Allemand (Allemagne)",
    format_estonian: "Estonien (Estonie)",
    format_english_gb: "Anglais (Royaume-Uni)",
    format_english_us: "Anglais (États-Unis)",
    format_spanish: "Espagnol (Espagne)",
    format_french: "Français (France)",
    format_italian: "Italien (Italie)",
    format_dutch: "Néerlandais (Pays-Bas)",
    format_portuguese: "Portugais (Portugal)",
    format_finnish: "Finnois (Finlande)",
    format_swedish: "Suédois (Suède)",
    openbanking_availability: "Disponibilité Open Banking",
    openbanking_availability_description: "Informations sur les banques disponibles par région",
    openbanking_country_info: "Le pays sélectionné détermine quelles banques seront disponibles via Open Banking. MoneyLights a accès à toutes les banques de l'Union européenne via notre intégration Yapily.",
    eu_countries_supported: "27 pays de l'UE",
    compliant: "Conforme",
    powered: "Powered",
    openbanking_available: "Open Banking disponible",
    openbanking_available_description: "Vous pouvez connecter toutes les banques disponibles dans ce pays via Open Banking.",
    openbanking_limited: "Open Banking limité",
    openbanking_limited_description: "Ce pays a une disponibilité Open Banking limitée. Seules les banques de l'UE sont disponibles.",
    manage_bank_connections: "Gérer les connexions bancaires",
    learn_more_openbanking: "En savoir plus",
    notification_preferences: "Préférences de Notification",
    notification_preferences_description: "Configurer comment recevoir les alertes",
    document_request_uploads: "Téléversements de documents demandés",
    document_request_uploads_description: "Recevoir une notification lorsqu’une personne téléverse un document demandé",
    notification_preferences_update_error: "Impossible d’enregistrer les préférences de notification.",
    notification_preferences_update_success: "Préférences de notification enregistrées.",
    budget_alerts: "Alertes de Budget",
    budget_alerts_description: "Être notifié lors de l'approche des limites de budget",
    transaction_updates: "Mises à jour de Transactions",
    transaction_updates_description: "Recevoir des notifications pour les nouvelles transactions",
    weekly_summary: "Résumé Hebdomadaire",
    weekly_summary_description: "Recevoir un résumé financier hebdomadaire par e-mail",
    ai_insights: "Insights IA",
    ai_insights_description: "Recevoir des insights financiers générés par l'IA",
    cashflow_warnings: "Avertissements de Flux de Trésorerie",
    cashflow_warnings_description: "M'alerter quand le flux de trésorerie devient négatif",
    monthly_reports: "Rapports Mensuels",
    monthly_reports_description: "Recevoir des rapports financiers mensuels",
    email_change_title: "Adresse e-mail",
    email_change_description: "Mettez à jour votre e-mail de connexion",
    current_email: "E-mail actuel",
    new_email: "Nouvel e-mail",
    email_change_hint: "Nous enverrons un lien de confirmation au nouvel e-mail.",
    request_email_change: "Demander le changement d’e-mail",
    requesting_email_change: "Demande en cours...",
    email_change_success: "Vérifiez votre nouvel e-mail pour confirmer le changement.",
    email_change_error_missing_fields: "Saisissez un nouvel e-mail et votre mot de passe actuel.",
    email_change_error_invalid_password: "Mot de passe incorrect.",
    email_change_error_in_use: "Cet e-mail est déjà utilisé.",
    email_change_error_invalid_email: "Veuillez saisir une adresse e-mail valide.",
    email_change_error_unchanged: "Le nouvel e-mail est identique à l’actuel.",
    email_change_error_generic: "Impossible de demander le changement d’e-mail.",
    password: "Mot de passe",
    password_description: "Changer votre mot de passe",
    current_password: "Mot de passe Actuel",
    new_password: "Nouveau Mot de passe",
    confirm_new_password: "Confirmer le Nouveau Mot de passe",
    change_password: "Changer le Mot de passe",
    connected_accounts: "Comptes Connectés",
    connected_accounts_description: "Gérer les méthodes d'authentification",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Connecté",
    enabled: "Activé",
    connect: "Connecter",
    disable: "Désactiver",
    cancel: "Annuler",
    copy: "Copier",
    copied: "Copié",
    connect_google_account: "Connecter votre compte Google",
    connect_microsoft_account: "Connecter votre compte Microsoft",
    connect_apple_id: "Connecter votre identifiant Apple",
    two_factor_authentication: "Authentification à Deux Facteurs",
    two_factor_authentication_description: "Ajouter une couche de sécurité supplémentaire",
    two_factor_auth_label: "Authentification à Deux Facteurs",
    two_factor_setup_title: "Configurer votre application d’authentification",
    two_factor_setup_description: "Saisissez cette clé dans votre application d’authentification puis validez avec un code à 6 chiffres.",
    two_factor_setup_qr_label: "Scanner le code QR",
    two_factor_setup_qr_hint: "Scannez avec votre application d’authentification pour ajouter MoneyLights.",
    two_factor_setup_qr_alt: "Code QR de l’authentificateur",
    two_factor_qr_loading: "Génération du code QR...",
    two_factor_qr_unavailable: "Code QR indisponible. Utilisez la clé de configuration.",
    two_factor_setup_key_label: "Clé de configuration",
    two_factor_verification_code: "Code de vérification",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Activer la 2FA",
    two_factor_disable_title: "Désactiver l’authentification à deux facteurs",
    two_factor_disable_description: "Saisissez un code de votre application d’authentification ou un code de récupération pour désactiver.",
    two_factor_disable_use_recovery: "Utiliser un code de récupération",
    two_factor_disable_button: "Désactiver la 2FA",
    two_factor_recovery_title: "Codes de récupération",
    two_factor_recovery_description: "Conservez ces codes en lieu sûr. Chaque code ne peut être utilisé qu’une seule fois.",
    two_factor_recovery_copy: "Copier les codes de récupération",
    two_factor_recovery_done: "Je les ai sauvegardés",
    two_factor_recovery_left: "Codes de récupération restants : {{count}}",
    two_factor_error_invalid: "Code invalide. Réessayez.",
    two_factor_error_generic: "Impossible de mettre à jour l’authentification à deux facteurs.",
    not_enabled: "Non activée",
    enable: "Activer",
    active_sessions: "Sessions Actives",
    active_sessions_description: "Gérer vos sessions de connexion actives",
    active_sessions_loading: "Chargement des sessions...",
    current_session: "Session Actuelle",
    other_session: "Autre session",
    current_session_details: "Lisbonne, Portugal • Chrome sur Mac",
    active: "Active",
    sign_out_all_other_sessions: "Déconnecter toutes les autres sessions",
    active_sessions_revoked: "Toutes les autres sessions ont été déconnectées.",
    active_sessions_error: "Impossible de déconnecter les autres sessions.",
    support: "Support & Aide",
    support_description: "Obtenez de l'aide et envoyez des retours sur MoneyLights",
    contact_support: "Contacter le support",
    contact_support_description: "Parlez à notre équipe pour des questions ou des problèmes",
    contact_us: "Contactez-nous",
    feedback: "Envoyer des retours",
    feedback_description: "Partagez vos suggestions ou signalez des problèmes",
    give_feedback: "Donner un retour",
  },
  it: {
    title: "Impostazioni",
    description: "Configurare le preferenze dell'account",
    tab_general: "GENERALE",
    tab_notifications: "NOTIFICHE",
    tab_security: "SICUREZZA",
    tab_support: "SUPPORTO",
    regional_settings: "Impostazioni Regionali",
    regional_settings_description: "Configurare posizione e lingua",
    scope_user: "Utente",
    scope_organization: "Organizzazione",
    organization_settings: "Organizzazione",
    organization_settings_description: "Aggiorna il nome mostrato nella barra superiore",
    organization_name: "Nome dell'organizzazione",
    organization_name_placeholder: "Nome dell'organizzazione",
    organization_name_save: "Salva nome",
    organization_name_saving: "Salvataggio...",
    organization_name_success: "Nome dell'organizzazione aggiornato.",
    organization_name_error: "Impossibile aggiornare il nome dell'organizzazione.",
    organization_name_required: "Il nome dell'organizzazione è obbligatorio.",
    organization_logo_success: "Logo dell'organizzazione aggiornato.",
    organization_logo_removed: "Logo dell'organizzazione rimosso.",
    organization_logo_error: "Impossibile aggiornare il logo dell'organizzazione.",
    country: "Paese",
    country_bank_filter_note: "Le connessioni bancarie disponibili saranno filtrate in base al paese selezionato",
    language: "Lingua",
    regional_formatting: "Formattazione Regionale",
    timezone: "Fuso Orario",
    default_currency: "Valuta Predefinita",
    country_austria: "Austria",
    country_belgium: "Belgio",
    country_bulgaria: "Bulgaria",
    country_croatia: "Croazia",
    country_cyprus: "Cipro",
    country_czechia: "Repubblica Ceca",
    country_denmark: "Danimarca",
    country_estonia: "Estonia",
    country_finland: "Finlandia",
    country_france: "Francia",
    country_germany: "Germania",
    country_greece: "Grecia",
    country_hungary: "Ungheria",
    country_ireland: "Irlanda",
    country_italy: "Italia",
    country_latvia: "Lettonia",
    country_lithuania: "Lituania",
    country_luxembourg: "Lussemburgo",
    country_malta: "Malta",
    country_netherlands: "Paesi Bassi",
    country_poland: "Polonia",
    country_portugal: "Portogallo",
    country_romania: "Romania",
    country_slovakia: "Slovacchia",
    country_slovenia: "Slovenia",
    country_spain: "Spagna",
    country_sweden: "Svezia",
    language_portuguese: "Portoghese",
    language_english: "Inglese",
    language_spanish: "Spagnolo",
    language_estonian: "Estone",
    format_danish: "Danese (Danimarca)",
    format_german: "Tedesco (Germania)",
    format_estonian: "Estone (Estonia)",
    format_english_gb: "Inglese (Regno Unito)",
    format_english_us: "Inglese (Stati Uniti)",
    format_spanish: "Spagnolo (Spagna)",
    format_french: "Francese (Francia)",
    format_italian: "Italiano (Italia)",
    format_dutch: "Olandese (Paesi Bassi)",
    format_portuguese: "Portoghese (Portogallo)",
    format_finnish: "Finlandese (Finlandia)",
    format_swedish: "Svedese (Svezia)",
    openbanking_availability: "Disponibilità Open Banking",
    openbanking_availability_description: "Informazioni sulle banche disponibili per regione",
    openbanking_country_info: "Il paese selezionato determina quali banche saranno disponibili tramite Open Banking. MoneyLights ha accesso a tutte le banche dell'Unione Europea tramite la nostra integrazione Yapily.",
    eu_countries_supported: "27 paesi UE",
    compliant: "Conforme",
    powered: "Powered",
    openbanking_available: "Open Banking disponibile",
    openbanking_available_description: "Puoi collegare tutte le banche disponibili in questo paese tramite Open Banking.",
    openbanking_limited: "Open Banking limitato",
    openbanking_limited_description: "Questo paese ha disponibilità Open Banking limitata. Sono disponibili solo le banche UE.",
    manage_bank_connections: "Gestisci connessioni bancarie",
    learn_more_openbanking: "Scopri di più",
    notification_preferences: "Preferenze di Notifica",
    notification_preferences_description: "Configurare come ricevere gli avvisi",
    document_request_uploads: "Caricamenti di documenti richiesti",
    document_request_uploads_description: "Ricevi una notifica quando qualcuno carica un documento richiesto",
    notification_preferences_update_error: "Impossibile salvare le preferenze di notifica.",
    notification_preferences_update_success: "Preferenze di notifica salvate.",
    budget_alerts: "Avvisi di Budget",
    budget_alerts_description: "Essere notificati all'avvicinarsi ai limiti del budget",
    transaction_updates: "Aggiornamenti Transazioni",
    transaction_updates_description: "Ricevere notifiche per nuove transazioni",
    weekly_summary: "Riepilogo Settimanale",
    weekly_summary_description: "Ricevere un riepilogo finanziario settimanale via email",
    ai_insights: "Approfondimenti IA",
    ai_insights_description: "Ricevere approfondimenti finanziari generati dall'IA",
    cashflow_warnings: "Avvisi di Flusso di Cassa",
    cashflow_warnings_description: "Avvisami quando il flusso di cassa diventa negativo",
    monthly_reports: "Rapporti Mensili",
    monthly_reports_description: "Ricevere rapporti finanziari mensili",
    email_change_title: "Indirizzo email",
    email_change_description: "Aggiorna l’email di accesso",
    current_email: "Email attuale",
    new_email: "Nuova email",
    email_change_hint: "Invieremo un link di conferma al nuovo indirizzo email.",
    request_email_change: "Richiedi cambio email",
    requesting_email_change: "Richiesta in corso...",
    email_change_success: "Controlla la nuova email per confermare la modifica.",
    email_change_error_missing_fields: "Inserisci una nuova email e la tua password attuale.",
    email_change_error_invalid_password: "Password errata.",
    email_change_error_in_use: "Questa email è già in uso.",
    email_change_error_invalid_email: "Inserisci un indirizzo email valido.",
    email_change_error_unchanged: "La nuova email coincide con quella attuale.",
    email_change_error_generic: "Impossibile richiedere il cambio email.",
    password: "Password",
    password_description: "Cambiare la password",
    current_password: "Password Attuale",
    new_password: "Nuova Password",
    confirm_new_password: "Conferma Nuova Password",
    change_password: "Cambia Password",
    connected_accounts: "Account Connessi",
    connected_accounts_description: "Gestire i metodi di autenticazione",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Connesso",
    enabled: "Attivato",
    connect: "Connetti",
    disable: "Disattiva",
    cancel: "Annulla",
    copy: "Copia",
    copied: "Copiato",
    connect_google_account: "Connetti account Google",
    connect_microsoft_account: "Connetti account Microsoft",
    connect_apple_id: "Connetti ID Apple",
    two_factor_authentication: "Autenticazione a Due Fattori",
    two_factor_authentication_description: "Aggiungere un ulteriore livello di sicurezza",
    two_factor_auth_label: "Autenticazione a Due Fattori",
    two_factor_setup_title: "Configura l'app di autenticazione",
    two_factor_setup_description: "Inserisci questa chiave nella tua app di autenticazione e verifica con un codice a 6 cifre.",
    two_factor_setup_qr_label: "Scansiona il codice QR",
    two_factor_setup_qr_hint: "Scansiona con la tua app di autenticazione per aggiungere MoneyLights.",
    two_factor_setup_qr_alt: "Codice QR dell'autenticatore",
    two_factor_qr_loading: "Generazione del codice QR...",
    two_factor_qr_unavailable: "Codice QR non disponibile. Usa la chiave di configurazione.",
    two_factor_setup_key_label: "Chiave di configurazione",
    two_factor_verification_code: "Codice di verifica",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Abilita 2FA",
    two_factor_disable_title: "Disattiva l'autenticazione a due fattori",
    two_factor_disable_description: "Inserisci un codice dalla tua app di autenticazione o un codice di recupero per disattivare.",
    two_factor_disable_use_recovery: "Usa un codice di recupero",
    two_factor_disable_button: "Disattiva 2FA",
    two_factor_recovery_title: "Codici di recupero",
    two_factor_recovery_description: "Conserva questi codici in un luogo sicuro. Ogni codice può essere usato una sola volta.",
    two_factor_recovery_copy: "Copia codici di recupero",
    two_factor_recovery_done: "Li ho salvati",
    two_factor_recovery_left: "Codici di recupero rimasti: {{count}}",
    two_factor_error_invalid: "Codice non valido. Riprova.",
    two_factor_error_generic: "Impossibile aggiornare l'autenticazione a due fattori.",
    not_enabled: "Non abilitata",
    enable: "Abilita",
    active_sessions: "Sessioni Attive",
    active_sessions_description: "Gestire le sessioni di accesso attive",
    active_sessions_loading: "Caricamento sessioni...",
    current_session: "Sessione Attuale",
    other_session: "Altra sessione",
    current_session_details: "Lisbona, Portogallo • Chrome su Mac",
    active: "Attiva",
    sign_out_all_other_sessions: "Disconnetti tutte le altre sessioni",
    active_sessions_revoked: "Tutte le altre sessioni sono state disconnesse.",
    active_sessions_error: "Impossibile disconnettere le altre sessioni.",
    support: "Supporto e Aiuto",
    support_description: "Ottieni aiuto e invia feedback su MoneyLights",
    contact_support: "Contatta il supporto",
    contact_support_description: "Parla con il nostro team per domande o problemi",
    contact_us: "Contattaci",
    feedback: "Invia feedback",
    feedback_description: "Condividi i tuoi suggerimenti o segnala problemi",
    give_feedback: "Lascia feedback",
  },
  nl: {
    title: "Instellingen",
    description: "Configureer uw accountvoorkeuren",
    tab_general: "ALGEMEEN",
    tab_notifications: "MELDINGEN",
    tab_security: "BEVEILIGING",
    tab_support: "ONDERSTEUNING",
    regional_settings: "Regionale Instellingen",
    regional_settings_description: "Configureer locatie en taal",
    scope_user: "Gebruiker",
    scope_organization: "Organisatie",
    organization_settings: "Organisatie",
    organization_settings_description: "Werk de naam in de bovenste balk bij",
    organization_name: "Organisatienaam",
    organization_name_placeholder: "Organisatienaam",
    organization_name_save: "Naam opslaan",
    organization_name_saving: "Opslaan...",
    organization_name_success: "Organisatienaam bijgewerkt.",
    organization_name_error: "Kan organisatienaam niet bijwerken.",
    organization_name_required: "Organisatienaam is verplicht.",
    organization_logo_success: "Organisatielogo bijgewerkt.",
    organization_logo_removed: "Organisatielogo verwijderd.",
    organization_logo_error: "Kan organisatielogo niet bijwerken.",
    country: "Land",
    country_bank_filter_note: "Beschikbare bankverbindingen worden gefilterd op basis van het geselecteerde land",
    language: "Taal",
    regional_formatting: "Regionale Opmaak",
    timezone: "Tijdzone",
    default_currency: "Standaardvaluta",
    country_austria: "Oostenrijk",
    country_belgium: "België",
    country_bulgaria: "Bulgarije",
    country_croatia: "Kroatië",
    country_cyprus: "Cyprus",
    country_czechia: "Tsjechië",
    country_denmark: "Denemarken",
    country_estonia: "Estland",
    country_finland: "Finland",
    country_france: "Frankrijk",
    country_germany: "Duitsland",
    country_greece: "Griekenland",
    country_hungary: "Hongarije",
    country_ireland: "Ierland",
    country_italy: "Italië",
    country_latvia: "Letland",
    country_lithuania: "Litouwen",
    country_luxembourg: "Luxemburg",
    country_malta: "Malta",
    country_netherlands: "Nederland",
    country_poland: "Polen",
    country_portugal: "Portugal",
    country_romania: "Roemenië",
    country_slovakia: "Slowakije",
    country_slovenia: "Slovenië",
    country_spain: "Spanje",
    country_sweden: "Zweden",
    language_portuguese: "Portugees",
    language_english: "Engels",
    language_spanish: "Spaans",
    language_estonian: "Ests",
    format_danish: "Deens (Denemarken)",
    format_german: "Duits (Duitsland)",
    format_estonian: "Ests (Estland)",
    format_english_gb: "Engels (Verenigd Koninkrijk)",
    format_english_us: "Engels (Verenigde Staten)",
    format_spanish: "Spaans (Spanje)",
    format_french: "Frans (Frankrijk)",
    format_italian: "Italiaans (Italië)",
    format_dutch: "Nederlands (Nederland)",
    format_portuguese: "Portugees (Portugal)",
    format_finnish: "Fins (Finland)",
    format_swedish: "Zweeds (Zweden)",
    openbanking_availability: "Open Banking beschikbaarheid",
    openbanking_availability_description: "Informatie over beschikbare banken per regio",
    openbanking_country_info: "Het geselecteerde land bepaalt welke banken beschikbaar zijn voor verbinding via Open Banking. MoneyLights heeft toegang tot alle banken in de Europese Unie via onze Yapily-integratie.",
    eu_countries_supported: "27 EU-landen",
    compliant: "Conform",
    powered: "Powered",
    openbanking_available: "Open Banking beschikbaar",
    openbanking_available_description: "U kunt alle beschikbare banken in dit land via Open Banking koppelen.",
    openbanking_limited: "Open Banking beperkt",
    openbanking_limited_description: "Dit land heeft beperkte Open Banking-beschikbaarheid. Alleen EU-banken zijn beschikbaar.",
    manage_bank_connections: "Bankverbindingen beheren",
    learn_more_openbanking: "Meer informatie",
    notification_preferences: "Meldingsvoorkeuren",
    notification_preferences_description: "Configureer hoe u meldingen ontvangt",
    document_request_uploads: "Uploads van aangevraagde documenten",
    document_request_uploads_description: "Ontvang een melding wanneer iemand een aangevraagd document uploadt",
    notification_preferences_update_error: "Kan meldingsvoorkeuren niet opslaan.",
    notification_preferences_update_success: "Meldingsvoorkeuren opgeslagen.",
    budget_alerts: "Budgetwaarschuwingen",
    budget_alerts_description: "Word gewaarschuwd bij nadering van budgetlimieten",
    transaction_updates: "Transactie-updates",
    transaction_updates_description: "Ontvang meldingen voor nieuwe transacties",
    weekly_summary: "Wekelijkse Samenvatting",
    weekly_summary_description: "Ontvang een wekelijkse financiële samenvatting per e-mail",
    ai_insights: "AI-Inzichten",
    ai_insights_description: "Ontvang door AI gegenereerde financiële inzichten",
    cashflow_warnings: "Cashflow-waarschuwingen",
    cashflow_warnings_description: "Waarschuw me wanneer de cashflow negatief wordt",
    monthly_reports: "Maandelijkse Rapporten",
    monthly_reports_description: "Ontvang maandelijkse financiële rapporten",
    email_change_title: "E-mailadres",
    email_change_description: "Werk je aanmeld-e-mail bij",
    current_email: "Huidige e-mail",
    new_email: "Nieuwe e-mail",
    email_change_hint: "We sturen een bevestigingslink naar het nieuwe e-mailadres.",
    request_email_change: "E-mailwijziging aanvragen",
    requesting_email_change: "Bezig met aanvragen...",
    email_change_success: "Controleer je nieuwe e-mail om de wijziging te bevestigen.",
    email_change_error_missing_fields: "Voer een nieuw e-mailadres en je huidige wachtwoord in.",
    email_change_error_invalid_password: "Onjuist wachtwoord.",
    email_change_error_in_use: "Dit e-mailadres is al in gebruik.",
    email_change_error_invalid_email: "Voer een geldig e-mailadres in.",
    email_change_error_unchanged: "De nieuwe e-mail is gelijk aan de huidige.",
    email_change_error_generic: "E-mailwijziging aanvragen mislukt.",
    password: "Wachtwoord",
    password_description: "Wijzig uw wachtwoord",
    current_password: "Huidig Wachtwoord",
    new_password: "Nieuw Wachtwoord",
    confirm_new_password: "Bevestig Nieuw Wachtwoord",
    change_password: "Wachtwoord Wijzigen",
    connected_accounts: "Verbonden Accounts",
    connected_accounts_description: "Beheer authenticatiemethoden",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Verbonden",
    enabled: "Ingeschakeld",
    connect: "Verbinden",
    disable: "Uitschakelen",
    cancel: "Annuleren",
    copy: "Kopiëren",
    copied: "Gekopieerd",
    connect_google_account: "Verbind uw Google-account",
    connect_microsoft_account: "Verbind uw Microsoft-account",
    connect_apple_id: "Verbind uw Apple ID",
    two_factor_authentication: "Twee-Factor-Authenticatie",
    two_factor_authentication_description: "Voeg een extra beveiligingslaag toe",
    two_factor_auth_label: "Twee-Factor-Authenticatie",
    two_factor_setup_title: "Authenticator-app instellen",
    two_factor_setup_description: "Voer deze sleutel in je authenticator-app in en bevestig met een 6-cijferige code.",
    two_factor_setup_qr_label: "QR-code scannen",
    two_factor_setup_qr_hint: "Scan met je authenticator-app om MoneyLights toe te voegen.",
    two_factor_setup_qr_alt: "Authenticator QR-code",
    two_factor_qr_loading: "QR-code genereren...",
    two_factor_qr_unavailable: "QR-code niet beschikbaar. Gebruik de instelsleutel.",
    two_factor_setup_key_label: "Instelsleutel",
    two_factor_verification_code: "Verificatiecode",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "2FA inschakelen",
    two_factor_disable_title: "Tweefactorauthenticatie uitschakelen",
    two_factor_disable_description: "Voer een code uit je authenticator-app of een herstelcode in om uit te schakelen.",
    two_factor_disable_use_recovery: "Gebruik een herstelcode",
    two_factor_disable_button: "2FA uitschakelen",
    two_factor_recovery_title: "Herstelcodes",
    two_factor_recovery_description: "Bewaar deze codes op een veilige plek. Elke code kan maar één keer gebruikt worden.",
    two_factor_recovery_copy: "Herstelcodes kopiëren",
    two_factor_recovery_done: "Ik heb ze opgeslagen",
    two_factor_recovery_left: "Herstelcodes over: {{count}}",
    two_factor_error_invalid: "Ongeldige code. Probeer het opnieuw.",
    two_factor_error_generic: "Tweefactorauthenticatie kon niet worden bijgewerkt.",
    not_enabled: "Niet ingeschakeld",
    enable: "Inschakelen",
    active_sessions: "Actieve Sessies",
    active_sessions_description: "Beheer uw actieve inlogsessies",
    active_sessions_loading: "Sessies laden...",
    current_session: "Huidige Sessie",
    other_session: "Andere sessie",
    current_session_details: "Lissabon, Portugal • Chrome op Mac",
    active: "Actief",
    sign_out_all_other_sessions: "Alle andere sessies uitloggen",
    active_sessions_revoked: "Alle andere sessies zijn afgemeld.",
    active_sessions_error: "Andere sessies konden niet worden afgemeld.",
    support: "Ondersteuning en hulp",
    support_description: "Krijg hulp en stuur feedback over MoneyLights",
    contact_support: "Contact opnemen met support",
    contact_support_description: "Neem contact op met ons team voor vragen of problemen",
    contact_us: "Neem contact op",
    feedback: "Feedback versturen",
    feedback_description: "Deel je suggesties of meld problemen",
    give_feedback: "Feedback geven",
  },
  pt: {
    title: "Definições",
    description: "Configurar as preferências da sua conta e definições da aplicação",
    tab_general: "GERAL",
    tab_notifications: "NOTIFICAÇÕES",
    tab_security: "SEGURANÇA",
    tab_support: "SUPORTE",
    regional_settings: "Definições Regionais",
    regional_settings_description: "Configurar as suas preferências de localização e idioma",
    scope_user: "Utilizador",
    scope_organization: "Organização",
    organization_settings: "Organização",
    organization_settings_description: "Atualize o nome apresentado na barra superior",
    organization_name: "Nome da organização",
    organization_name_placeholder: "Nome da organização",
    organization_name_save: "Guardar nome",
    organization_name_saving: "A guardar...",
    organization_name_success: "Nome da organização atualizado.",
    organization_name_error: "Não foi possível atualizar o nome da organização.",
    organization_name_required: "O nome da organização é obrigatório.",
    organization_logo_success: "Logótipo da organização atualizado.",
    organization_logo_removed: "Logótipo da organização removido.",
    organization_logo_error: "Não foi possível atualizar o logótipo da organização.",
    country: "País",
    country_bank_filter_note: "As ligações bancárias disponíveis serão filtradas com base no país selecionado",
    language: "Idioma",
    regional_formatting: "Formatação regional",
    timezone: "Fuso horário",
    default_currency: "Moeda padrão",
    country_austria: "��ustria",
    country_belgium: "Bélgica",
    country_bulgaria: "Bulgária",
    country_croatia: "Croácia",
    country_cyprus: "Chipre",
    country_czechia: "República Checa",
    country_denmark: "Dinamarca",
    country_estonia: "Estónia",
    country_finland: "Finlândia",
    country_france: "França",
    country_germany: "Alemanha",
    country_greece: "Grécia",
    country_hungary: "Hungria",
    country_ireland: "Irlanda",
    country_italy: "Itália",
    country_latvia: "Letónia",
    country_lithuania: "Lituânia",
    country_luxembourg: "Luxemburgo",
    country_malta: "Malta",
    country_netherlands: "Países Baixos",
    country_poland: "Polónia",
    country_portugal: "Portugal",
    country_romania: "Roménia",
    country_slovakia: "Eslováquia",
    country_slovenia: "Eslovénia",
    country_spain: "Espanha",
    country_sweden: "Su��cia",
    language_portuguese: "Português",
    language_english: "English",
    language_spanish: "Español",
    language_estonian: "Eesti",
    format_danish: "Dinamarquês (Dinamarca)",
    format_german: "Alemão (Alemanha)",
    format_estonian: "Estoniano (Estónia)",
    format_english_gb: "Inglês (Reino Unido)",
    format_english_us: "Inglês (Estados Unidos)",
    format_spanish: "Espanhol (Espanha)",
    format_french: "Francês (França)",
    format_italian: "Italiano (Itália)",
    format_dutch: "Holandês (Países Baixos)",
    format_portuguese: "Português (Portugal)",
    format_finnish: "Finlandês (Finlândia)",
    format_swedish: "Sueco (Suécia)",
    openbanking_availability: "Disponibilidade Open Banking",
    openbanking_availability_description: "Informação sobre bancos disponíveis por região",
    openbanking_country_info: "O país selecionado determina quais bancos estarão disponíveis para ligação via Open Banking. MoneyLights tem acesso a todos os bancos da União Europeia através da nossa integração Yapily.",
    eu_countries_supported: "27 Países UE",
    compliant: "Conforme",
    powered: "Powered",
    openbanking_available: "Open Banking Disponível",
    openbanking_available_description: "Pode ligar todos os bancos disponíveis neste país via Open Banking.",
    openbanking_limited: "Open Banking Limitado",
    openbanking_limited_description: "Este país tem disponibilidade limitada de Open Banking. Apenas bancos da UE estão disponíveis.",
    manage_bank_connections: "Gerir Ligações Bancárias",
    learn_more_openbanking: "Saber Mais",
    notification_preferences: "Preferências de Notificação",
    notification_preferences_description: "Configurar como recebe alertas",
    document_request_uploads: "Uploads de documentação pedida",
    document_request_uploads_description: "Receber notificação quando alguém carrega um documento pedido",
    notification_preferences_update_error: "Não foi possível guardar as preferências de notificações.",
    notification_preferences_update_success: "Preferências de notificações guardadas.",
    budget_alerts: "Alertas de Orçamento",
    budget_alerts_description: "Ser notificado ao aproximar-se dos limites de orçamento",
    transaction_updates: "Atualizações de Transações",
    transaction_updates_description: "Receber notificações para novas transações",
    weekly_summary: "Resumo Semanal",
    weekly_summary_description: "Receber um resumo financeiro semanal por email",
    ai_insights: "Insights de IA",
    ai_insights_description: "Receber insights financeiros gerados por IA",
    cashflow_warnings: "Avisos de Fluxo de Caixa",
    cashflow_warnings_description: "Alertar-me quando o fluxo de caixa ficar negativo",
    monthly_reports: "Relatórios Mensais",
    monthly_reports_description: "Receber relatórios financeiros mensais",
    email_change_title: "Endereço de email",
    email_change_description: "Atualiza o teu email de acesso",
    current_email: "Email atual",
    new_email: "Novo email",
    email_change_hint: "Vamos enviar um link de confirmação para o novo email.",
    request_email_change: "Pedir alteração de email",
    requesting_email_change: "A pedir...",
    email_change_success: "Verifica o novo email para confirmar a alteração.",
    email_change_error_missing_fields: "Introduz um novo email e a tua palavra-passe atual.",
    email_change_error_invalid_password: "Palavra-passe incorreta.",
    email_change_error_in_use: "Este email já está a ser utilizado.",
    email_change_error_invalid_email: "Introduz um endereço de email válido.",
    email_change_error_unchanged: "O novo email é igual ao atual.",
    email_change_error_generic: "Não foi possível pedir a alteração de email.",
    password: "Palavra-passe",
    password_description: "Alterar a sua palavra-passe",
    current_password: "Palavra-passe Atual",
    new_password: "Nova Palavra-passe",
    confirm_new_password: "Confirmar Nova Palavra-passe",
    change_password: "Alterar Palavra-passe",
    connected_accounts: "Contas Conectadas",
    connected_accounts_description: "Gerir métodos de autenticação para a sua conta",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Conectado",
    enabled: "Ativado",
    connect: "Conectar",
    disable: "Desativar",
    cancel: "Cancelar",
    copy: "Copiar",
    copied: "Copiado",
    connect_google_account: "Conectar a sua conta Google",
    connect_microsoft_account: "Conectar a sua conta Microsoft",
    connect_apple_id: "Conectar o seu Apple ID",
    two_factor_authentication: "Autenticação de Dois Fatores",
    two_factor_authentication_description: "Adicionar uma camada extra de segurança à sua conta",
    two_factor_auth_label: "Autenticação de Dois Fatores",
    two_factor_setup_title: "Configurar app de autenticação",
    two_factor_setup_description: "Introduza esta chave na sua app de autenticação e confirme com um código de 6 dígitos.",
    two_factor_setup_qr_label: "Digitalizar QR code",
    two_factor_setup_qr_hint: "Digitalize com a sua app de autenticação para adicionar o MoneyLights.",
    two_factor_setup_qr_alt: "QR code do autenticador",
    two_factor_qr_loading: "A gerar QR code...",
    two_factor_qr_unavailable: "QR code indisponível. Use a chave de configuração.",
    two_factor_setup_key_label: "Chave de configuração",
    two_factor_verification_code: "Código de verificação",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Ativar 2FA",
    two_factor_disable_title: "Desativar autenticação de dois fatores",
    two_factor_disable_description: "Introduza um código da sua app de autenticação ou um código de recuperação para desativar.",
    two_factor_disable_use_recovery: "Usar um código de recuperação",
    two_factor_disable_button: "Desativar 2FA",
    two_factor_recovery_title: "Códigos de recuperação",
    two_factor_recovery_description: "Guarde estes códigos num local seguro. Cada código só pode ser usado uma vez.",
    two_factor_recovery_copy: "Copiar códigos de recuperação",
    two_factor_recovery_done: "Já os guardei",
    two_factor_recovery_left: "Códigos de recuperação restantes: {{count}}",
    two_factor_error_invalid: "Código inválido. Tente novamente.",
    two_factor_error_generic: "Não foi possível atualizar a autenticação de dois fatores.",
    not_enabled: "Não ativada",
    enable: "Ativar",
    active_sessions: "Sessões Ativas",
    active_sessions_description: "Gerir as suas sessões de login ativas",
    active_sessions_loading: "A carregar sessões...",
    current_session: "Sessão Atual",
    other_session: "Outra sessão",
    current_session_details: "Lisboa, Portugal • Chrome no Mac",
    active: "Ativa",
    sign_out_all_other_sessions: "Terminar Todas as Outras Sessões",
    active_sessions_revoked: "Todas as outras sessões foram terminadas.",
    active_sessions_error: "Não foi possível terminar as outras sessões.",
    support: "Suporte & Ajuda",
    support_description: "Obter ajuda e enviar feedback sobre o MoneyLights",
    contact_support: "Contactar Suporte",
    contact_support_description: "Falar com a nossa equipa para questões ou problemas",
    contact_us: "Contactar-nos",
    feedback: "Enviar Feedback",
    feedback_description: "Partilhar as suas sugestões ou reportar problemas",
    give_feedback: "Dar Feedback",
  },
  sv: {
    title: "Inställningar",
    description: "Konfigurera dina kontoinställningar",
    tab_general: "ALLMÄNT",
    tab_notifications: "MEDDELANDEN",
    tab_security: "SÄKERHET",
    tab_support: "SUPPORT",
    regional_settings: "Regionala Inställningar",
    regional_settings_description: "Konfigurera plats och språk",
    scope_user: "Användare",
    scope_organization: "Organisation",
    organization_settings: "Organisation",
    organization_settings_description: "Uppdatera namnet som visas i toppfältet",
    organization_name: "Organisationsnamn",
    organization_name_placeholder: "Organisationsnamn",
    organization_name_save: "Spara namn",
    organization_name_saving: "Sparar...",
    organization_name_success: "Organisationsnamnet har uppdaterats.",
    organization_name_error: "Det gick inte att uppdatera organisationsnamnet.",
    organization_name_required: "Organisationsnamn är obligatoriskt.",
    organization_logo_success: "Organisationslogotyp uppdaterad.",
    organization_logo_removed: "Organisationslogotyp borttagen.",
    organization_logo_error: "Det gick inte att uppdatera organisationslogotypen.",
    country: "Land",
    country_bank_filter_note: "Tillgängliga bankförbindelser filtreras baserat på det valda landet",
    language: "Språk",
    regional_formatting: "Regional Formatering",
    timezone: "Tidszon",
    default_currency: "Standardvaluta",
    country_austria: "Österrike",
    country_belgium: "Belgien",
    country_bulgaria: "Bulgarien",
    country_croatia: "Kroatien",
    country_cyprus: "Cypern",
    country_czechia: "Tjeckien",
    country_denmark: "Danmark",
    country_estonia: "Estland",
    country_finland: "Finland",
    country_france: "Frankrike",
    country_germany: "Tyskland",
    country_greece: "Grekland",
    country_hungary: "Ungern",
    country_ireland: "Irland",
    country_italy: "Italien",
    country_latvia: "Lettland",
    country_lithuania: "Litauen",
    country_luxembourg: "Luxemburg",
    country_malta: "Malta",
    country_netherlands: "Nederländerna",
    country_poland: "Polen",
    country_portugal: "Portugal",
    country_romania: "Rumänien",
    country_slovakia: "Slovakien",
    country_slovenia: "Slovenien",
    country_spain: "Spanien",
    country_sweden: "Sverige",
    language_portuguese: "Portugisiska",
    language_english: "Engelska",
    language_spanish: "Spanska",
    language_estonian: "Estniska",
    format_danish: "Danska (Danmark)",
    format_german: "Tyska (Tyskland)",
    format_estonian: "Estniska (Estland)",
    format_english_gb: "Engelska (Storbritannien)",
    format_english_us: "Engelska (USA)",
    format_spanish: "Spanska (Spanien)",
    format_french: "Franska (Frankrike)",
    format_italian: "Italienska (Italien)",
    format_dutch: "Nederländska (Nederländerna)",
    format_portuguese: "Portugisiska (Portugal)",
    format_finnish: "Finska (Finland)",
    format_swedish: "Svenska (Sverige)",
    openbanking_availability: "Open Banking-tillgänglighet",
    openbanking_availability_description: "Information om tillgängliga banker per region",
    openbanking_country_info: "Det valda landet avgör vilka banker som är tillgängliga för anslutning via Open Banking. MoneyLights har tillgång till alla EU-banker via vår Yapily-integrering.",
    eu_countries_supported: "27 EU-länder",
    compliant: "Förenlig",
    powered: "Powered",
    openbanking_available: "Open Banking tillgängligt",
    openbanking_available_description: "Du kan ansluta alla tillgängliga banker i detta land via Open Banking.",
    openbanking_limited: "Open Banking begränsat",
    openbanking_limited_description: "Detta land har begränsad Open Banking-tillgänglighet. Endast EU-banker är tillgängliga.",
    manage_bank_connections: "Hantera bankanslutningar",
    learn_more_openbanking: "Läs mer",
    notification_preferences: "Meddelandeinställningar",
    notification_preferences_description: "Konfigurera hur du tar emot aviseringar",
    document_request_uploads: "Uppladdningar av begärda dokument",
    document_request_uploads_description: "Få en avisering när någon laddar upp ett begärt dokument",
    notification_preferences_update_error: "Det gick inte att spara aviseringarna.",
    notification_preferences_update_success: "Aviseringarna har sparats.",
    budget_alerts: "Budgetvarningar",
    budget_alerts_description: "Bli meddelad när budgetgränser närmar sig",
    transaction_updates: "Transaktionsuppdateringar",
    transaction_updates_description: "Ta emot meddelanden för nya transaktioner",
    weekly_summary: "Veckosammanfattning",
    weekly_summary_description: "Ta emot en veckovis finansiell sammanfattning via e-post",
    ai_insights: "AI-Insikter",
    ai_insights_description: "Ta emot AI-genererade finansiella insikter",
    cashflow_warnings: "Kassaflödesvarningar",
    cashflow_warnings_description: "Varna mig när kassaflödet blir negativt",
    monthly_reports: "Månadsrapporter",
    monthly_reports_description: "Ta emot månatliga finansiella rapporter",
    email_change_title: "E-postadress",
    email_change_description: "Uppdatera din inloggningsadress",
    current_email: "Nuvarande e-post",
    new_email: "Ny e-post",
    email_change_hint: "Vi skickar en bekräftelselänk till den nya e-postadressen.",
    request_email_change: "Begär ändring av e-post",
    requesting_email_change: "Begär...",
    email_change_success: "Kontrollera din nya e-post för att bekräfta ändringen.",
    email_change_error_missing_fields: "Ange en ny e-post och ditt nuvarande lösenord.",
    email_change_error_invalid_password: "Fel lösenord.",
    email_change_error_in_use: "Den e-posten används redan.",
    email_change_error_invalid_email: "Ange en giltig e-postadress.",
    email_change_error_unchanged: "Den nya e-posten matchar den nuvarande.",
    email_change_error_generic: "Kunde inte begära ändring av e-post.",
    password: "Lösenord",
    password_description: "Ändra ditt lösenord",
    current_password: "Nuvarande Lösenord",
    new_password: "Nytt Lösenord",
    confirm_new_password: "Bekräfta Nytt Lösenord",
    change_password: "Ändra Lösenord",
    connected_accounts: "Anslutna Konton",
    connected_accounts_description: "Hantera autentiseringsmetoder",
    google: "Google",
    microsoft: "Microsoft",
    apple: "Apple",
    connected: "Ansluten",
    enabled: "Aktiverad",
    connect: "Anslut",
    disable: "Inaktivera",
    cancel: "Avbryt",
    copy: "Kopiera",
    copied: "Kopierad",
    connect_google_account: "Anslut ditt Google-konto",
    connect_microsoft_account: "Anslut ditt Microsoft-konto",
    connect_apple_id: "Anslut ditt Apple-ID",
    two_factor_authentication: "Tvåfaktorsautentisering",
    two_factor_authentication_description: "Lägg till ett extra säkerhetslager",
    two_factor_auth_label: "Tvåfaktorsautentisering",
    two_factor_setup_title: "Ställ in autentiseringsapp",
    two_factor_setup_description: "Ange den här nyckeln i din autentiseringsapp och bekräfta med en 6-siffrig kod.",
    two_factor_setup_qr_label: "Skanna QR-kod",
    two_factor_setup_qr_hint: "Skanna med din autentiseringsapp för att lägga till MoneyLights.",
    two_factor_setup_qr_alt: "QR-kod för autentisering",
    two_factor_qr_loading: "Skapar QR-kod...",
    two_factor_qr_unavailable: "QR-koden är inte tillgänglig. Använd inställningsnyckeln.",
    two_factor_setup_key_label: "Konfigurationsnyckel",
    two_factor_verification_code: "Verifieringskod",
    two_factor_verification_code_placeholder: "123 456",
    two_factor_enable_button: "Aktivera 2FA",
    two_factor_disable_title: "Inaktivera tvåfaktorsautentisering",
    two_factor_disable_description: "Ange en kod från din autentiseringsapp eller en återställningskod för att inaktivera.",
    two_factor_disable_use_recovery: "Använd en återställningskod",
    two_factor_disable_button: "Inaktivera 2FA",
    two_factor_recovery_title: "Återställningskoder",
    two_factor_recovery_description: "Spara dessa koder på ett säkert ställe. Varje kod kan bara användas en gång.",
    two_factor_recovery_copy: "Kopiera återställningskoder",
    two_factor_recovery_done: "Jag har sparat dem",
    two_factor_recovery_left: "Återställningskoder kvar: {{count}}",
    two_factor_error_invalid: "Ogiltig kod. Försök igen.",
    two_factor_error_generic: "Det gick inte att uppdatera tvåfaktorsautentisering.",
    not_enabled: "Inte aktiverad",
    enable: "Aktivera",
    active_sessions: "Aktiva Sessioner",
    active_sessions_description: "Hantera dina aktiva inloggningssessioner",
    active_sessions_loading: "Laddar sessioner...",
    current_session: "Nuvarande Session",
    other_session: "Annan session",
    current_session_details: "Lissabon, Portugal • Chrome på Mac",
    active: "Aktiv",
    sign_out_all_other_sessions: "Logga ut alla andra sessioner",
    active_sessions_revoked: "Alla andra sessioner har loggats ut.",
    active_sessions_error: "Det gick inte att logga ut andra sessioner.",
    support: "Support & Hjälp",
    support_description: "Få hjälp och skicka feedback om MoneyLights",
    contact_support: "Kontakta support",
    contact_support_description: "Prata med vårt team vid frågor eller problem",
    contact_us: "Kontakta oss",
    feedback: "Skicka feedback",
    feedback_description: "Dela dina förslag eller rapportera problem",
    give_feedback: "Ge feedback",
  },
};
